(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/forms"), require("@angular/common"), require("rxjs/Observable"), require("@angular/animations"), require("rxjs/add/operator/first"), require("rxjs/BehaviorSubject"), require("@angular/router"), require("@angular/platform-browser/animations"), require("rxjs/add/observable/fromEvent"), require("rxjs/add/observable/of"), require("rxjs/add/operator/delay"), require("rxjs/add/operator/do"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/forms", "@angular/common", "rxjs/Observable", "@angular/animations", "rxjs/add/operator/first", "rxjs/BehaviorSubject", "@angular/router", "@angular/platform-browser/animations", "rxjs/add/observable/fromEvent", "rxjs/add/observable/of", "rxjs/add/operator/delay", "rxjs/add/operator/do"], factory);
	else if(typeof exports === 'object')
		exports["ticktock"] = factory(require("@angular/core"), require("@angular/forms"), require("@angular/common"), require("rxjs/Observable"), require("@angular/animations"), require("rxjs/add/operator/first"), require("rxjs/BehaviorSubject"), require("@angular/router"), require("@angular/platform-browser/animations"), require("rxjs/add/observable/fromEvent"), require("rxjs/add/observable/of"), require("rxjs/add/operator/delay"), require("rxjs/add/operator/do"));
	else
		root["ticktock"] = factory(root["ng"]["core"], root["ng"]["forms"], root["ng"]["common"], root["Rx"], root["ng"]["animations"], root["Rx"], root["Rx"], root["ng"]["router"], root["ng"]["platformBrowserAnimations"], root["Rx"], root["Rx"], root["Rx"], root["Rx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_53__, __WEBPACK_EXTERNAL_MODULE_73__, __WEBPACK_EXTERNAL_MODULE_83__, __WEBPACK_EXTERNAL_MODULE_84__, __WEBPACK_EXTERNAL_MODULE_85__, __WEBPACK_EXTERNAL_MODULE_86__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie_options_provider__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(11);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var CookieService = (function () {
    function CookieService(_optionsProvider) {
        this._optionsProvider = _optionsProvider;
        this.options = this._optionsProvider.options;
    }
    Object.defineProperty(CookieService.prototype, "cookieString", {
        get: function () {
            return document.cookie || '';
        },
        set: function (val) {
            document.cookie = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @name CookieService#get
     *
     * @description
     * Returns the value of given cookie key.
     *
     * @param {string} key Id to use for lookup.
     * @returns {string} Raw cookie value.
     */
    CookieService.prototype.get = function (key) {
        return this._cookieReader()[key];
    };
    /**
     * @name CookieService#getObject
     *
     * @description
     * Returns the deserialized value of given cookie key.
     *
     * @param {string} key Id to use for lookup.
     * @returns {Object} Deserialized cookie value.
     */
    CookieService.prototype.getObject = function (key) {
        var value = this.get(key);
        return value ? Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* safeJsonParse */])(value) : value;
    };
    /**
     * @name CookieService#getAll
     *
     * @description
     * Returns a key value object with all the cookies.
     *
     * @returns {Object} All cookies
     */
    CookieService.prototype.getAll = function () {
        return this._cookieReader();
    };
    /**
     * @name CookieService#put
     *
     * @description
     * Sets a value for given cookie key.
     *
     * @param {string} key Id for the `value`.
     * @param {string} value Raw value to be stored.
     * @param {CookieOptions} options (Optional) Options object.
     */
    CookieService.prototype.put = function (key, value, options) {
        this._cookieWriter()(key, value, options);
    };
    /**
     * @name CookieService#putObject
     *
     * @description
     * Serializes and sets a value for given cookie key.
     *
     * @param {string} key Id for the `value`.
     * @param {Object} value Value to be stored.
     * @param {CookieOptions} options (Optional) Options object.
     */
    CookieService.prototype.putObject = function (key, value, options) {
        this.put(key, JSON.stringify(value), options);
    };
    /**
     * @name CookieService#remove
     *
     * @description
     * Remove given cookie.
     *
     * @param {string} key Id of the key-value pair to delete.
     * @param {CookieOptions} options (Optional) Options object.
     */
    CookieService.prototype.remove = function (key, options) {
        this._cookieWriter()(key, undefined, options);
    };
    /**
     * @name CookieService#removeAll
     *
     * @description
     * Remove all cookies.
     */
    CookieService.prototype.removeAll = function () {
        var _this = this;
        var cookies = this.getAll();
        Object.keys(cookies).forEach(function (key) {
            _this.remove(key);
        });
    };
    CookieService.prototype._cookieReader = function () {
        var lastCookies = {};
        var lastCookieString = '';
        var cookieArray, cookie, i, index, name;
        var currentCookieString = this.cookieString;
        if (currentCookieString !== lastCookieString) {
            lastCookieString = currentCookieString;
            cookieArray = lastCookieString.split('; ');
            lastCookies = {};
            for (i = 0; i < cookieArray.length; i++) {
                cookie = cookieArray[i];
                index = cookie.indexOf('=');
                if (index > 0) {
                    name = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* safeDecodeURIComponent */])(cookie.substring(0, index));
                    // the first value that is seen for a cookie is the most
                    // specific one.  values for the same cookie name that
                    // follow are for less specific paths.
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* isBlank */])(lastCookies[name])) {
                        lastCookies[name] = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* safeDecodeURIComponent */])(cookie.substring(index + 1));
                    }
                }
            }
        }
        return lastCookies;
    };
    CookieService.prototype._cookieWriter = function () {
        var that = this;
        return function (name, value, options) {
            that.cookieString = that._buildCookieString(name, value, options);
        };
    };
    CookieService.prototype._buildCookieString = function (name, value, options) {
        var opts = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mergeOptions */])(this.options, options);
        var expires = opts.expires;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* isBlank */])(value)) {
            expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
            value = '';
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* isString */])(expires)) {
            expires = new Date(expires);
        }
        var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
        str += opts.path ? ';path=' + opts.path : '';
        str += opts.domain ? ';domain=' + opts.domain : '';
        str += expires ? ';expires=' + expires.toUTCString() : '';
        str += opts.secure ? ';secure' : '';
        // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
        // - 300 cookies
        // - 20 cookies per unique domain
        // - 4096 bytes per cookie
        var cookieLength = str.length + 1;
        if (cookieLength > 4096) {
            console.log("Cookie '" + name + "' possibly not set or overflowed because it was too \n      large (" + cookieLength + " > 4096 bytes)!");
        }
        return str;
    };
    return CookieService;
}());
CookieService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__cookie_options_provider__["b" /* CookieOptionsProvider */]])
], CookieService);



/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var library_config_interface_1 = __webpack_require__(7);
var core_1 = __webpack_require__(0);
var ngx_cookie_1 = __webpack_require__(9);
var TranslationsService = (function () {
    /**
     * Default constructor.
     *
     * @param {CookieService} cookies The cookies service.
     * @param {LibraryConfig} config The library config data.
     */
    function TranslationsService(cookies, config) {
        this.cookies = cookies;
        this.config = config;
        /**
         * The dictionary containing the translations.
         * @type {object}
         */
        this.dictionary = {};
        // Validate the config.
        if (!config) {
            throw new Error('The forRoot method was not called properly.');
        }
        // Retrieve the languages from the config.
        this.dictionary = config.languages;
        // Check if the languages are all correct and if the application is in development mode.
        if (!this.valid()) {
            console.warn('LANGUAGE_EXCEPTION: The language files have been compared ' +
                'and they have not passed the validation.');
        }
        // Retrieve the current language.
        var language = this.cookies.get('APP_TRANSLATION');
        // Verify the language.
        var verifiedLanguage = this.verify(language);
        // Use the verified language.
        this.use(verifiedLanguage);
    }
    /**
     * Set the current language to a new value.
     *
     * @param {string} language The new language.
     */
    TranslationsService.prototype.use = function (language) {
        if (!this.dictionary.hasOwnProperty(language)) {
            return;
        }
        this.language = language;
        this.cookies.put('APP_TRANSLATION', this.language);
    };
    /**
     * Translates a key.
     *
     * @param {string} key The key to translate.
     *
     * @returns {string} The translated key.
     */
    TranslationsService.prototype.instant = function (key) {
        return this.translate(key);
    };
    /**
     * Verifies if the language was supported.
     *
     * @param {string} language The supplied language.
     *
     * @returns {string} The validated language.
     */
    TranslationsService.prototype.verify = function (language) {
        // Check if the language exists.
        var hasProperty = language ? this.dictionary.hasOwnProperty(language) : false;
        if (language !== null && typeof language === 'object' && hasProperty) {
            return language;
        }
        // Fetch the browser language.
        var browserLanguage = navigator.language;
        // Check if the browsers language is supported in the system.
        if (!this.dictionary.hasOwnProperty(browserLanguage)) {
            browserLanguage = Object.keys(this.dictionary)[0] || 'en';
        }
        // If the browser language was not supported put one in the cookie.
        this.cookies.put('APP_TRANSLATION', browserLanguage);
        // Return the browser language.
        return browserLanguage;
    };
    /**
     * Translates a key to the current language equivalent.
     *
     * @param {string} key The key to translate.
     *
     * @returns {string} The translated key.
     */
    TranslationsService.prototype.translate = function (key) {
        // Validate if the language does exist in the dictionary, else throw an error.
        if (!this.dictionary.hasOwnProperty(this.language)) {
            return key;
        }
        // Retrieve the current language dictionary object.
        var dictionary = this.dictionary[this.language];
        // Check if the dictionary contains the key then return the translated value.
        if (dictionary && dictionary.hasOwnProperty(key)) {
            return dictionary[key];
        }
        // Warn the user that current key was not found.
        console.warn("LANGUAGE_EXCEPTION: The translation-key {\"" + key + "\": \"\"} was not found");
        // Return the original key.
        return key;
    };
    /**
     * @returns {boolean} The validity of the dictionary files.
     */
    TranslationsService.prototype.valid = function () {
        var _this = this;
        var array = [];
        // Loop through each dictionary file.
        Object.keys(this.dictionary).forEach(function (languageKey) {
            var language = _this.dictionary[languageKey];
            if (!language) {
                return;
            }
            // Retrieve the keys.
            var data = _this.getKeys(language);
            // Add the data to the array.
            array.push(data);
        });
        var first = array[0] || [];
        // Compare all arrays.
        return array.every(function (element) { return _this.compare(first, element); });
    };
    /**
     * Retrieve the keys of an object in a string array format.
     *
     * @param {object} object The object containing the data.
     * @param {string} id The current identifier for the data.
     *
     * @returns {string[]} A string array containing the keys.
     */
    TranslationsService.prototype.getKeys = function (object, id) {
        var _this = this;
        if (id === void 0) { id = null; }
        var result = [];
        Object.keys(object).forEach(function (key) {
            var item = object[key];
            if (typeof item === 'object') {
                result.push.apply(result, _this.getKeys(item, id ? (id + '.' + key) : key));
            }
            else {
                result.push(id ? (id + '.' + key) : key);
            }
        });
        return result;
    };
    /**
     * Compares two string arrays.
     *
     * @param {string[]} first The first string array.
     * @param {string[]} second The second string array.
     *
     * @returns {boolean} True if the arrays are equal, else false.
     */
    TranslationsService.prototype.compare = function (first, second) {
        if (first === second) {
            return true;
        }
        if (first === null || second === null) {
            return false;
        }
        if (first.length !== second.length) {
            return false;
        }
        for (var index = 0; index < first.length; ++index) {
            if (first[index] !== second[index]) {
                return false;
            }
        }
        return true;
    };
    return TranslationsService;
}());
TranslationsService = __decorate([
    core_1.Injectable(),
    __param(1, core_1.Optional()),
    __metadata("design:paramtypes", [ngx_cookie_1.CookieService, library_config_interface_1.LibraryConfig])
], TranslationsService);
exports.TranslationsService = TranslationsService;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LibraryConfig = (function () {
    function LibraryConfig() {
    }
    return LibraryConfig;
}());
exports.LibraryConfig = LibraryConfig;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(6));
__export(__webpack_require__(12));


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CookieModule", function() { return CookieModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_cookie_options_provider__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cookie_service__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cookie_factory__ = __webpack_require__(20);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CookieService", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cookie_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_cookie_backend_service__ = __webpack_require__(21);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CookieBackendService", function() { return __WEBPACK_IMPORTED_MODULE_4__src_cookie_backend_service__["a"]; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var CookieModule = CookieModule_1 = (function () {
    function CookieModule() {
    }
    /**
     * Use this method in your root module to provide the CookieService
     * @param {CookieOptions} options
     * @returns {ModuleWithProviders}
     */
    CookieModule.forRoot = function (options) {
        if (options === void 0) { options = {}; }
        return {
            ngModule: CookieModule_1,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_1__src_cookie_options_provider__["a" /* COOKIE_OPTIONS */], useValue: options },
                { provide: __WEBPACK_IMPORTED_MODULE_2__src_cookie_service__["a" /* CookieService */], useFactory: __WEBPACK_IMPORTED_MODULE_3__src_cookie_factory__["a" /* cookieServiceFactory */], deps: [__WEBPACK_IMPORTED_MODULE_1__src_cookie_options_provider__["b" /* CookieOptionsProvider */]] }
            ]
        };
    };
    /**
     * Use this method in your other (non root) modules to import the directive/pipe
     * @param {CookieOptions} options
     * @returns {ModuleWithProviders}
     */
    CookieModule.forChild = function (options) {
        if (options === void 0) { options = {}; }
        return {
            ngModule: CookieModule_1,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_1__src_cookie_options_provider__["a" /* COOKIE_OPTIONS */], useValue: options },
                { provide: __WEBPACK_IMPORTED_MODULE_2__src_cookie_service__["a" /* CookieService */], useFactory: __WEBPACK_IMPORTED_MODULE_3__src_cookie_factory__["a" /* cookieServiceFactory */], deps: [__WEBPACK_IMPORTED_MODULE_1__src_cookie_options_provider__["b" /* CookieOptionsProvider */]] }
            ]
        };
    };
    return CookieModule;
}());
CookieModule = CookieModule_1 = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
        providers: [__WEBPACK_IMPORTED_MODULE_1__src_cookie_options_provider__["b" /* CookieOptionsProvider */]]
    })
], CookieModule);

var CookieModule_1;


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COOKIE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CookieOptionsProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(11);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};



var COOKIE_OPTIONS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('COOKIE_OPTIONS');
/** @private */
var CookieOptionsProvider = (function () {
    function CookieOptionsProvider(options, _injector) {
        if (options === void 0) { options = {}; }
        this._injector = _injector;
        this.defaultOptions = {
            path: this._injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_common__["APP_BASE_HREF"], '/'),
            domain: null,
            expires: null,
            secure: false
        };
        this._options = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mergeOptions */])(this.defaultOptions, options);
    }
    Object.defineProperty(CookieOptionsProvider.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: true,
        configurable: true
    });
    return CookieOptionsProvider;
}());
CookieOptionsProvider = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __param(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(COOKIE_OPTIONS)),
    __metadata("design:paramtypes", [Object, __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"]])
], CookieOptionsProvider);



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBlank;
/* unused harmony export isPresent */
/* harmony export (immutable) */ __webpack_exports__["b"] = isString;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeOptions;
/* harmony export (immutable) */ __webpack_exports__["d"] = safeDecodeURIComponent;
/* harmony export (immutable) */ __webpack_exports__["e"] = safeJsonParse;
function isBlank(obj) {
    return obj === undefined || obj === null;
}
function isPresent(obj) {
    return obj !== undefined && obj !== null;
}
function isString(obj) {
    return typeof obj === 'string';
}
function mergeOptions(oldOptions, newOptions) {
    if (!newOptions) {
        return oldOptions;
    }
    return {
        path: isPresent(newOptions.path) ? newOptions.path : oldOptions.path,
        domain: isPresent(newOptions.domain) ? newOptions.domain : oldOptions.domain,
        expires: isPresent(newOptions.expires) ? newOptions.expires : oldOptions.expires,
        secure: isPresent(newOptions.secure) ? newOptions.secure : oldOptions.secure,
    };
}
function safeDecodeURIComponent(str) {
    try {
        return decodeURIComponent(str);
    }
    catch (e) {
        return str;
    }
}
function safeJsonParse(str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BehaviorSubject_1 = __webpack_require__(23);
var Observable_1 = __webpack_require__(5);
var core_1 = __webpack_require__(0);
var NotificationsService = (function () {
    function NotificationsService() {
        // Data.
        this.list = [];
        this.list$ = new BehaviorSubject_1.BehaviorSubject(this.list);
    }
    Object.defineProperty(NotificationsService.prototype, "items", {
        /**
         * @returns An observable basic-list of notifications.
         */
        get: function () {
            return this.list$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a new notifications to the notifications-list.
     *
     * @param {string} message The message of the notification.
     * @param {string} type The type of notification.
     */
    NotificationsService.prototype.create = function (message, type) {
        var _this = this;
        if (type === void 0) { type = 'success'; }
        var id = this.getId();
        var item = { type: type, message: message, id: id };
        // Add the new item.
        this.add(item);
        // Remove it after 3000 milliseconds.
        Observable_1.Observable
            .of(item)
            .delay(3000)
            .first()
            .subscribe(function (item) { return _this.remove(item); });
    };
    /**
     * Adds a new notification to the array.
     *
     * @param item The notification item.
     */
    NotificationsService.prototype.add = function (item) {
        this.list.push(item);
        this.list$.next(this.list);
    };
    /**
     * Removes an item from the array.
     *
     * @param item The notification item.
     */
    NotificationsService.prototype.remove = function (item) {
        var _this = this;
        this.list.forEach(function (notification, index) {
            if (notification.id === item.id) {
                _this.list.splice(index, 1);
            }
        });
        this.list$.next(this.list);
    };
    /**
     * @returns A random id for the notification.
     */
    NotificationsService.prototype.getId = function () {
        return Math.random().toString(36).substr(2, 10);
    };
    return NotificationsService;
}());
NotificationsService = __decorate([
    core_1.Injectable()
], NotificationsService);
exports.NotificationsService = NotificationsService;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(24));
__export(__webpack_require__(28));
__export(__webpack_require__(32));
__export(__webpack_require__(36));
__export(__webpack_require__(40));
__export(__webpack_require__(44));
__export(__webpack_require__(48));
__export(__webpack_require__(52));
__export(__webpack_require__(57));
__export(__webpack_require__(61));
__export(__webpack_require__(65));


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(69));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(70));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(2);
var select_component_css_1 = __webpack_require__(75);
var select_component_html_1 = __webpack_require__(76);
var option_list_1 = __webpack_require__(77);
exports.SELECT_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return SelectComponent; }),
    multi: true
};
var SelectComponent = (function () {
    function SelectComponent(hostElement) {
        this.hostElement = hostElement;
        // Data input.
        this.options = [];
        // Functionality settings.
        this.allowClear = false;
        this.disabled = false;
        this.multiple = false;
        this.noFilter = 0;
        // Text settings.
        this.notFoundMsg = 'No results found';
        this.placeholder = '';
        this.filterPlaceholder = '';
        this.label = '';
        // Output events.
        this.opened = new core_1.EventEmitter();
        this.closed = new core_1.EventEmitter();
        this.selected = new core_1.EventEmitter();
        this.deselected = new core_1.EventEmitter();
        this.focus = new core_1.EventEmitter();
        this.blur = new core_1.EventEmitter();
        this.noOptionsFound = new core_1.EventEmitter();
        this._value = [];
        this.optionList = new option_list_1.OptionList([]);
        // View state variables.
        this.hasFocus = false;
        this.isOpen = false;
        this.isBelow = true;
        this.filterEnabled = true;
        this.filterInputWidth = 1;
        this.isDisabled = false;
        this.placeholderView = '';
        this.clearClicked = false;
        this.selectContainerClicked = false;
        this.optionListClicked = false;
        this.optionClicked = false;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        /** Keys. **/
        this.KEYS = {
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            ESC: 27,
            SPACE: 32,
            UP: 38,
            DOWN: 40
        };
    }
    /** Event handlers. **/
    SelectComponent.prototype.ngOnInit = function () {
        this.placeholderView = this.placeholder;
    };
    SelectComponent.prototype.ngOnChanges = function (changes) {
        this.handleInputChanges(changes);
    };
    SelectComponent.prototype.ngAfterViewInit = function () {
        this.updateState();
    };
    SelectComponent.prototype.onWindowBlur = function () {
        this._blur();
    };
    SelectComponent.prototype.onWindowClick = function () {
        if (!this.selectContainerClicked &&
            (!this.optionListClicked || (this.optionListClicked && this.optionClicked))) {
            this.closeDropdown(this.optionClicked);
            if (!this.optionClicked) {
                this._blur();
            }
        }
        this.clearClicked = false;
        this.selectContainerClicked = false;
        this.optionListClicked = false;
        this.optionClicked = false;
    };
    SelectComponent.prototype.onWindowResize = function () {
        this.updateWidth();
    };
    SelectComponent.prototype.onSelectContainerClick = function (event) {
        this.selectContainerClicked = true;
        if (!this.clearClicked) {
            this.toggleDropdown();
        }
    };
    SelectComponent.prototype.onSelectContainerFocus = function () {
        this._focus();
    };
    SelectComponent.prototype.onSelectContainerKeydown = function (event) {
        this.handleSelectContainerKeydown(event);
    };
    SelectComponent.prototype.onOptionsListClick = function () {
        this.optionListClicked = true;
    };
    SelectComponent.prototype.onDropdownOptionClicked = function (option) {
        this.optionClicked = true;
        this.multiple ? this.toggleSelectOption(option) : this.selectOption(option);
    };
    SelectComponent.prototype.onSingleFilterClick = function () {
        this.selectContainerClicked = true;
    };
    SelectComponent.prototype.onSingleFilterFocus = function () {
        this._focus();
    };
    SelectComponent.prototype.onFilterInput = function (term) {
        this.filter(term);
    };
    SelectComponent.prototype.onSingleFilterKeydown = function (event) {
        this.handleSingleFilterKeydown(event);
    };
    SelectComponent.prototype.onMultipleFilterKeydown = function (event) {
        this.handleMultipleFilterKeydown(event);
    };
    SelectComponent.prototype.onMultipleFilterFocus = function () {
        this._focus();
    };
    SelectComponent.prototype.onClearSelectionClick = function (event) {
        this.clearClicked = true;
        this.clearSelection();
        this.closeDropdown(true);
    };
    SelectComponent.prototype.onDeselectOptionClick = function (option) {
        this.clearClicked = true;
        this.deselectOption(option);
    };
    /** API. **/
    // TODO fix issues with global click/key handler that closes the dropdown.
    SelectComponent.prototype.open = function () {
        this.openDropdown();
    };
    SelectComponent.prototype.close = function () {
        this.closeDropdown(false);
    };
    SelectComponent.prototype.clear = function () {
        this.clearSelection();
    };
    SelectComponent.prototype.select = function (value) {
        this.writeValue(value);
    };
    /** ControlValueAccessor interface methods. **/
    SelectComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    SelectComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    SelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    SelectComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /** Input change handling. **/
    SelectComponent.prototype.handleInputChanges = function (changes) {
        var optionsChanged = changes.hasOwnProperty('options');
        var noFilterChanged = changes.hasOwnProperty('noFilter');
        var placeholderChanged = changes.hasOwnProperty('placeholder');
        if (optionsChanged) {
            this.updateOptionList(changes.options.currentValue);
        }
        if (optionsChanged || noFilterChanged) {
            this.updateFilterEnabled();
        }
        if (placeholderChanged) {
            this.updateState();
        }
    };
    SelectComponent.prototype.updateOptionList = function (options) {
        this.optionList = new option_list_1.OptionList(options);
        this.optionList.value = this._value;
    };
    SelectComponent.prototype.updateFilterEnabled = function () {
        this.filterEnabled = this.optionList.options.length >= this.noFilter;
    };
    Object.defineProperty(SelectComponent.prototype, "value", {
        /** Value. **/
        get: function () {
            return this.multiple ? this._value : this._value[0];
        },
        set: function (v) {
            if (typeof v === 'undefined' || v === null || v === '') {
                v = [];
            }
            else if (typeof v === 'string') {
                v = [v];
            }
            else if (!Array.isArray(v)) {
                throw new TypeError('Value must be a string or an array.');
            }
            this.optionList.value = v;
            this._value = v;
            this.updateState();
        },
        enumerable: true,
        configurable: true
    });
    SelectComponent.prototype.valueChanged = function () {
        this._value = this.optionList.value;
        this.updateState();
        this.onChange(this.value);
    };
    SelectComponent.prototype.updateState = function () {
        this.placeholderView = this.optionList.hasSelected ? '' : this.placeholder;
        this.updateFilterWidth();
    };
    /** Select. **/
    SelectComponent.prototype.selectOption = function (option) {
        if (!option.selected && !option.disabled) {
            this.optionList.select(option, this.multiple);
            this.valueChanged();
            this.selected.emit(option.wrappedOption);
        }
    };
    SelectComponent.prototype.deselectOption = function (option) {
        var _this = this;
        if (option.selected) {
            this.optionList.deselect(option);
            this.valueChanged();
            this.deselected.emit(option.wrappedOption);
            setTimeout(function () {
                if (_this.multiple) {
                    _this.updatePosition();
                    _this.optionList.highlight();
                    if (_this.isOpen) {
                        _this.dropdown.moveHighlightedIntoView();
                    }
                }
            });
        }
    };
    SelectComponent.prototype.clearSelection = function () {
        var selection = this.optionList.selection;
        if (selection.length > 0) {
            this.optionList.clearSelection();
            this.valueChanged();
            if (selection.length === 1) {
                this.deselected.emit(selection[0].wrappedOption);
            }
            else {
                this.deselected.emit(selection.map(function (option) { return option.wrappedOption; }));
            }
        }
    };
    SelectComponent.prototype.toggleSelectOption = function (option) {
        option.selected ? this.deselectOption(option) : this.selectOption(option);
    };
    SelectComponent.prototype.selectHighlightedOption = function () {
        var option = this.optionList.highlightedOption;
        if (option !== null) {
            this.selectOption(option);
            this.closeDropdown(true);
        }
    };
    SelectComponent.prototype.deselectLast = function () {
        var sel = this.optionList.selection;
        if (sel.length > 0) {
            var option = sel[sel.length - 1];
            this.deselectOption(option);
            this.setMultipleFilterInput(option.label + ' ');
        }
    };
    /** Dropdown. **/
    SelectComponent.prototype.toggleDropdown = function () {
        if (!this.isDisabled) {
            this.isOpen ? this.closeDropdown(true) : this.openDropdown();
        }
    };
    SelectComponent.prototype.openDropdown = function () {
        if (!this.isOpen) {
            this.updateWidth();
            this.updatePosition();
            this.isOpen = true;
            if (this.multiple && this.filterEnabled) {
                this.filterInput.nativeElement.focus();
            }
            this.opened.emit(null);
        }
    };
    SelectComponent.prototype.closeDropdown = function (focus) {
        if (this.isOpen) {
            this.clearFilterInput();
            this.updateFilterWidth();
            this.isOpen = false;
            if (focus) {
                this._focusSelectContainer();
            }
            this.closed.emit(null);
        }
    };
    /** Filter. **/
    SelectComponent.prototype.filter = function (term) {
        var _this = this;
        if (this.multiple) {
            if (!this.isOpen) {
                this.openDropdown();
            }
            this.updateFilterWidth();
        }
        setTimeout(function () {
            var hasShown = _this.optionList.filter(term);
            if (!hasShown) {
                _this.noOptionsFound.emit(term);
            }
        });
    };
    SelectComponent.prototype.clearFilterInput = function () {
        if (this.multiple && this.filterEnabled) {
            this.filterInput.nativeElement.value = '';
        }
    };
    SelectComponent.prototype.setMultipleFilterInput = function (value) {
        if (this.filterEnabled) {
            this.filterInput.nativeElement.value = value;
        }
    };
    SelectComponent.prototype.handleSelectContainerKeydown = function (event) {
        var _this = this;
        var key = event.which;
        if (this.isOpen) {
            if (key === this.KEYS.ESC || (key === this.KEYS.UP && event.altKey)) {
                this.closeDropdown(true);
            }
            else if (key === this.KEYS.TAB) {
                this.closeDropdown(event.shiftKey);
                this._blur();
            }
            else if (key === this.KEYS.ENTER) {
                this.selectHighlightedOption();
            }
            else if (key === this.KEYS.UP) {
                this.optionList.highlightPreviousOption();
                this.dropdown.moveHighlightedIntoView();
                if (!this.filterEnabled) {
                    event.preventDefault();
                }
            }
            else if (key === this.KEYS.DOWN) {
                this.optionList.highlightNextOption();
                this.dropdown.moveHighlightedIntoView();
                if (!this.filterEnabled) {
                    event.preventDefault();
                }
            }
        }
        else {
            // DEPRICATED --> SPACE
            if (key === this.KEYS.ENTER || key === this.KEYS.SPACE ||
                (key === this.KEYS.DOWN && event.altKey)) {
                /* FIREFOX HACK:
                 *
                 * The setTimeout is added to prevent the enter keydown event
                 * to be triggered for the filter input field, which causes
                 * the dropdown to be closed again.
                 */
                setTimeout(function () { _this.openDropdown(); });
            }
            else if (key === this.KEYS.TAB) {
                this._blur();
            }
        }
    };
    SelectComponent.prototype.handleMultipleFilterKeydown = function (event) {
        var key = event.which;
        if (key === this.KEYS.BACKSPACE) {
            if (this.optionList.hasSelected && this.filterEnabled &&
                this.filterInput.nativeElement.value === '') {
                this.deselectLast();
            }
        }
    };
    SelectComponent.prototype.handleSingleFilterKeydown = function (event) {
        var key = event.which;
        if (key === this.KEYS.ESC || key === this.KEYS.TAB
            || key === this.KEYS.UP || key === this.KEYS.DOWN
            || key === this.KEYS.ENTER) {
            this.handleSelectContainerKeydown(event);
        }
    };
    /** View. **/
    SelectComponent.prototype._blur = function () {
        if (this.hasFocus) {
            this.hasFocus = false;
            this.onTouched();
            this.blur.emit(null);
        }
    };
    SelectComponent.prototype._focus = function () {
        if (!this.hasFocus) {
            this.hasFocus = true;
            this.focus.emit(null);
        }
    };
    SelectComponent.prototype._focusSelectContainer = function () {
        this.selectionSpan.nativeElement.focus();
    };
    SelectComponent.prototype.updateWidth = function () {
        this.width = this.selectionSpan.nativeElement.getBoundingClientRect().width;
    };
    SelectComponent.prototype.updatePosition = function () {
        var hostRect = this.hostElement.nativeElement.getBoundingClientRect();
        var spanRect = this.selectionSpan.nativeElement.getBoundingClientRect();
        this.left = spanRect.left - hostRect.left;
        this.top = (spanRect.top - hostRect.top) + spanRect.height;
    };
    SelectComponent.prototype.updateFilterWidth = function () {
        if (typeof this.filterInput !== 'undefined') {
            var value = this.filterInput.nativeElement.value;
            this.filterInputWidth = value.length === 0 ?
                1 + this.placeholderView.length * 10 : 1 + value.length * 10;
        }
    };
    return SelectComponent;
}());
SelectComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'ng-select',
                template: select_component_html_1.TEMPLATE,
                styles: [select_component_css_1.STYLE],
                providers: [exports.SELECT_VALUE_ACCESSOR],
                encapsulation: core_1.ViewEncapsulation.None
            },] },
];
/** @nocollapse */
SelectComponent.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
]; };
SelectComponent.propDecorators = {
    'options': [{ type: core_1.Input },],
    'allowClear': [{ type: core_1.Input },],
    'disabled': [{ type: core_1.Input },],
    'multiple': [{ type: core_1.Input },],
    'noFilter': [{ type: core_1.Input },],
    'highlightColor': [{ type: core_1.Input },],
    'highlightTextColor': [{ type: core_1.Input },],
    'notFoundMsg': [{ type: core_1.Input },],
    'placeholder': [{ type: core_1.Input },],
    'filterPlaceholder': [{ type: core_1.Input },],
    'label': [{ type: core_1.Input },],
    'opened': [{ type: core_1.Output },],
    'closed': [{ type: core_1.Output },],
    'selected': [{ type: core_1.Output },],
    'deselected': [{ type: core_1.Output },],
    'focus': [{ type: core_1.Output },],
    'blur': [{ type: core_1.Output },],
    'noOptionsFound': [{ type: core_1.Output },],
    'selectionSpan': [{ type: core_1.ViewChild, args: ['selection',] },],
    'dropdown': [{ type: core_1.ViewChild, args: ['dropdown',] },],
    'filterInput': [{ type: core_1.ViewChild, args: ['filterInput',] },],
    'optionTemplate': [{ type: core_1.ContentChild, args: ['optionTemplate',] },],
    'onWindowBlur': [{ type: core_1.HostListener, args: ['window:blur',] },],
    'onWindowClick': [{ type: core_1.HostListener, args: ['window:click',] },],
    'onWindowResize': [{ type: core_1.HostListener, args: ['window:resize',] },],
};
exports.SelectComponent = SelectComponent;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//
// Export all the services.
//
var services_1 = __webpack_require__(8);
exports.TranslationsService = services_1.TranslationsService;
exports.NotificationsService = services_1.NotificationsService;
//
// Export all the components.
//
var components_1 = __webpack_require__(13);
exports.FormControlComponent = components_1.FormControlComponent;
exports.CheckboxComponent = components_1.CheckboxComponent;
exports.RadioComponent = components_1.RadioComponent;
exports.SelectComponent = components_1.SelectComponent;
exports.ButtonComponent = components_1.ButtonComponent;
exports.ButtonGroupComponent = components_1.ButtonGroupComponent;
exports.CardComponent = components_1.CardComponent;
exports.ModalComponent = components_1.ModalComponent;
exports.DatePickerComponent = components_1.DatePickerComponent;
exports.TableComponent = components_1.TableComponent;
//
// Export all the pipes.
//
var pipes_1 = __webpack_require__(16);
exports.TranslatePipe = pipes_1.TranslatePipe;
//
// Export all the directives.
//
var directives_1 = __webpack_require__(17);
exports.ClickOutsideDirective = directives_1.ClickOutsideDirective;
//
// Export all the interfaces.
//
var interfaces_1 = __webpack_require__(71);
exports.LibraryConfig = interfaces_1.LibraryConfig;
//
// Export the library module.
//
var ngx_manager_module_1 = __webpack_require__(72);
exports.NgxManagerModule = ngx_manager_module_1.NgxManagerModule;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cookieServiceFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie_service__ = __webpack_require__(4);

function cookieServiceFactory(cookieOptionsProvider) {
    return new __WEBPACK_IMPORTED_MODULE_0__cookie_service__["a" /* CookieService */](cookieOptionsProvider);
}


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieBackendService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie_service__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var CookieBackendService = (function (_super) {
    __extends(CookieBackendService, _super);
    function CookieBackendService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CookieBackendService.prototype, "cookieString", {
        get: function () {
            return global.Zone.current.get('req').headers.cookie || '';
        },
        set: function (val) {
            global.Zone.current.get('req').headers.cookie = val;
            global.Zone.current.get('res').headers.cookie = val;
        },
        enumerable: true,
        configurable: true
    });
    return CookieBackendService;
}(__WEBPACK_IMPORTED_MODULE_1__cookie_service__["a" /* CookieService */]));
CookieBackendService = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
], CookieBackendService);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_23__;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var FormControlComponent = (function () {
    function FormControlComponent() {
        /**
         * If the icon should be reversed.
         * @type {boolean}
         */
        this.reversed = false;
        /**
         * If the form-control should have bottom margin.
         * @type {boolean}
         */
        this.grouped = true;
    }
    return FormControlComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FormControlComponent.prototype, "icon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FormControlComponent.prototype, "label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], FormControlComponent.prototype, "reversed", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], FormControlComponent.prototype, "grouped", void 0);
FormControlComponent = __decorate([
    core_1.Component({
        selector: 'bb-form-control',
        styles: [__webpack_require__(25)],
        template: __webpack_require__(27)
    })
], FormControlComponent);
exports.FormControlComponent = FormControlComponent;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(26);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ":host /deep/ .input {\n  width: 100%;\n  display: flex;\n  min-width: 80px;\n  position: relative;\n  background-color: #ffffff; }\n  :host /deep/ .input__label {\n    display: block;\n    margin-bottom: 5px; }\n  :host /deep/ .input__icon {\n    top: 0;\n    left: 0;\n    width: 34px;\n    height: 34px;\n    padding: 10px;\n    display: flex;\n    color: #aaaaaa;\n    font-size: 20px;\n    position: absolute;\n    border-radius: 2px;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent; }\n    :host /deep/ .input__icon + input, :host /deep/ .input__icon + textarea {\n      padding-left: 34px;\n      padding-right: 10px; }\n    :host /deep/ .input__icon + ng-select > div {\n      padding-left: 24px; }\n    :host /deep/ .input__icon--reversed {\n      right: 0;\n      left: auto; }\n      :host /deep/ .input__icon--reversed + input, :host /deep/ .input__icon--reversed + textarea {\n        padding-left: 10px;\n        padding-right: 34px; }\n      :host /deep/ .input__icon--reversed + ng-select > div {\n        padding-left: 0;\n        padding-right: 34px; }\n  :host /deep/ .input--grouped {\n    margin-bottom: 20px; }\n\n:host /deep/ input, :host /deep/ textarea {\n  margin: 0;\n  width: 100%;\n  height: 34px;\n  color: #3d464d;\n  font-size: 15px;\n  line-height: 34px;\n  padding-left: 10px;\n  border-radius: 3px;\n  padding-right: 10px;\n  -webkit-appearance: none;\n  border: 1px solid #bdc4c9;\n  box-shadow: 0 0 0 0 transparent;\n  transition: box-shadow 300ms cubic-bezier(0, 0, 0.2, 1); }\n  :host /deep/ input::-webkit-input-placeholder, :host /deep/ textarea::-webkit-input-placeholder {\n    color: #aaaaaa;\n    transition: color 300ms cubic-bezier(0, 0, 0.2, 1); }\n  :host /deep/ input::-moz-placeholder, :host /deep/ textarea::-moz-placeholder {\n    color: #aaaaaa;\n    transition: color 300ms cubic-bezier(0, 0, 0.2, 1); }\n  :host /deep/ input:-ms-input-placeholder, :host /deep/ textarea:-ms-input-placeholder {\n    color: #aaaaaa;\n    transition: color 300ms cubic-bezier(0, 0, 0.2, 1); }\n  :host /deep/ input:-moz-placeholder, :host /deep/ textarea:-moz-placeholder {\n    color: #aaaaaa;\n    transition: color 300ms cubic-bezier(0, 0, 0.2, 1); }\n  :host /deep/ input:focus, :host /deep/ textarea:focus {\n    box-shadow: 0 0 0 2px rgba(3, 102, 214, 0.1); }\n    :host /deep/ input:focus::-webkit-input-placeholder, :host /deep/ textarea:focus::-webkit-input-placeholder {\n      color: #e5e5e5; }\n    :host /deep/ input:focus::-moz-placeholder, :host /deep/ textarea:focus::-moz-placeholder {\n      color: #e5e5e5; }\n    :host /deep/ input:focus:-ms-input-placeholder, :host /deep/ textarea:focus:-ms-input-placeholder {\n      color: #e5e5e5; }\n    :host /deep/ input:focus:-moz-placeholder, :host /deep/ textarea:focus:-moz-placeholder {\n      color: #e5e5e5; }\n  :host /deep/ input:read-only:not(select):not(.input--date-picker--bb), :host /deep/ textarea:read-only:not(select):not(.input--date-picker--bb) {\n    color: rgba(0, 0, 0, 0.5);\n    background-color: rgba(204, 204, 204, 0.4); }\n  :host /deep/ input:disabled, :host /deep/ textarea:disabled {\n    cursor: default;\n    pointer-events: none;\n    color: rgba(0, 0, 0, 0.3);\n    background-color: rgba(204, 204, 204, 0.64); }\n\n:host /deep/ textarea {\n  resize: none;\n  height: 132px;\n  line-height: 1.5;\n  padding-top: 5px;\n  padding-bottom: 5px; }\n", ""]);

// exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = "<label [ngClass]=\"{'input--grouped': grouped}\">\n    <span class=\"input__label\" *ngIf=\"label\">{{ label | translate }}</span>\n    <span class=\"input\">\n        <span *ngIf=\"icon\" [ngClass]=\"{'input__icon--reversed': reversed}\" class=\"input__icon\">\n            <i class=\"material-icons\">{{ icon }}</i>\n        </span>\n        <ng-content></ng-content>\n    </span>\n</label>"

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var CheckboxComponent = CheckboxComponent_1 = (function () {
    function CheckboxComponent() {
        /**
         * If the checkbox should have bottom margin.
         * @type {boolean}
         */
        this.grouped = false;
        /**
         * If the checkbox should have single bottom margin.
         * @type {boolean}
         */
        this.single = false;
        // Callbacks.
        this.onTouchedCallback = function () {
        };
        this.onChangeCallback = function () {
        };
    }
    /**
     * Saves the new value.
     *
     * @param {boolean} value The new value of the checkbox.
     */
    CheckboxComponent.prototype.writeValue = function (value) {
        if (this.selected !== value) {
            this.selected = value;
        }
    };
    /**
     * Registers a change in the input.
     *
     * @param {(_: boolean) => void} method The onChange callback.
     */
    CheckboxComponent.prototype.registerOnChange = function (method) {
        this.onChangeCallback = method;
    };
    /**
     * Registers a touch.
     *
     * @param {() => void} method The touch callback.
     */
    CheckboxComponent.prototype.registerOnTouched = function (method) {
        this.onTouchedCallback = method;
    };
    /**
     * Triggers when the input is set to a disabled state.
     *
     * @param {boolean} isDisabled Boolean if the input is disabled.
     */
    CheckboxComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return CheckboxComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CheckboxComponent.prototype, "selected", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CheckboxComponent.prototype, "label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CheckboxComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CheckboxComponent.prototype, "grouped", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CheckboxComponent.prototype, "single", void 0);
CheckboxComponent = CheckboxComponent_1 = __decorate([
    core_1.Component({
        selector: 'bb-checkbox',
        template: __webpack_require__(29),
        styles: [__webpack_require__(30)],
        providers: [
            {
                provide: forms_1.NG_VALUE_ACCESSOR,
                useExisting: core_1.forwardRef(function () { return CheckboxComponent_1; }),
                multi: true
            }
        ]
    })
], CheckboxComponent);
exports.CheckboxComponent = CheckboxComponent;
var CheckboxComponent_1;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = "<label class=\"checkbox\"\r\n       [ngClass]=\"{'checkbox--grouped': grouped, 'checkbox--single': single, 'checkbox--disabled': disabled}\">\r\n    <input [(ngModel)]=\"selected\" [disabled]=\"disabled\" (ngModelChange)=\"onChangeCallback(selected)\"\r\n           class=\"checkbox__input\" type=\"checkbox\">\r\n    <span class=\"checkbox__label\" *ngIf=\"label\">{{ label | translate }}</span>\r\n</label>"

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(31);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".checkbox {\n  display: flex;\n  cursor: pointer;\n  margin-bottom: 5px;\n  align-items: center; }\n  .checkbox--grouped {\n    margin-bottom: 20px; }\n  .checkbox--single {\n    margin-bottom: 0; }\n  .checkbox__input {\n    width: 22px;\n    height: 22px;\n    cursor: pointer;\n    min-width: 22px;\n    appearance: none;\n    min-height: 22px;\n    position: relative;\n    border-radius: 2px;\n    -moz-appearance: none;\n    will-change: transform;\n    vertical-align: middle;\n    -webkit-appearance: none;\n    border: 1px solid #bdc4c9;\n    background-color: #ffffff;\n    box-shadow: inset 0 0 0 0 #4caf50;\n    transition: transform 0.3s cubic-bezier(0.2, 0.3, 0, 1), box-shadow 0.3s cubic-bezier(0.2, 0.3, 0, 1), border-color 0s linear 0.17s; }\n    .checkbox__input:focus {\n      outline: none; }\n    .checkbox__input:checked {\n      border-color: #4caf50;\n      box-shadow: inset 0 0 0 11px #4caf50;\n      transition: transform 0.3s cubic-bezier(0.2, 0.3, 0, 1), box-shadow 0.3s cubic-bezier(0.2, 0.3, 0, 1), border-color 0s; }\n    .checkbox__input:before, .checkbox__input:after {\n      top: -1px;\n      left: -2px;\n      content: '';\n      width: 22px;\n      height: 22px;\n      position: absolute;\n      will-change: opacity;\n      transform-origin: 0 0;\n      background-color: #ffffff;\n      transition: transform 0.3s cubic-bezier(0.2, 0.3, 0, 1), opacity 0.3s cubic-bezier(0.2, 0.3, 0, 1);\n      transform: translate(6.0016px, 9.4138px) rotate(44.91deg) scale(0.3411, 0.1); }\n    .checkbox__input:after {\n      transform: translate(18.6868px, 7.7px) rotate(135.22deg) scale(0.5612, 0.1); }\n    .checkbox__input:not(:checked):before {\n      transform: translate(11.11px, 10.01px) rotate(44.91deg) scale(0.1, 0.1); }\n    .checkbox__input:not(:checked):after {\n      transform: translate(12.65px, 11.55px) rotate(135.22deg) scale(0.1, 0.1); }\n  .checkbox__label {\n    font-weight: 400;\n    margin-left: 10px;\n    user-select: none; }\n  .checkbox--disabled {\n    cursor: default;\n    pointer-events: none; }\n    .checkbox--disabled > .checkbox__input {\n      box-shadow: inset 0 0 0 0 rgba(204, 204, 204, 0.64); }\n      .checkbox--disabled > .checkbox__input:checked {\n        border-color: rgba(204, 204, 204, 0.64);\n        box-shadow: inset 0 0 0 11px rgba(204, 204, 204, 0.64); }\n", ""]);

// exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var RadioComponent = RadioComponent_1 = (function () {
    function RadioComponent() {
        /**
         * If the radio should have bottom margin.
         * @type {boolean}
         */
        this.grouped = false;
        /**
         * If the radio is checked.
         * @type {boolean}
         */
        this.model = false;
        // ControlValueAccessor callbacks.
        this.onTouchedCallback = function () {
        };
        this.onChangeCallback = function () {
        };
    }
    /**
     * Saves the new value.
     *
     * @param {boolean} value The new value of the radio button.
     */
    RadioComponent.prototype.writeValue = function (value) {
        if (this.model !== value) {
            this.model = value;
        }
    };
    /**
     * Registers a change in the input.
     *
     * @param {(_: boolean) => void} method The onChange callback.
     */
    RadioComponent.prototype.registerOnChange = function (method) {
        this.onChangeCallback = method;
    };
    /**
     * Registers a touch.
     *
     * @param {() => void} method The touch callback.
     */
    RadioComponent.prototype.registerOnTouched = function (method) {
        this.onTouchedCallback = method;
    };
    /**
     * Triggers when the input is set to a disabled state.
     *
     * @param {boolean} isDisabled Boolean if the input is disabled.
     */
    RadioComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return RadioComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadioComponent.prototype, "value", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadioComponent.prototype, "name", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadioComponent.prototype, "label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], RadioComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], RadioComponent.prototype, "grouped", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], RadioComponent.prototype, "model", void 0);
RadioComponent = RadioComponent_1 = __decorate([
    core_1.Component({
        selector: 'bb-radio',
        template: __webpack_require__(33),
        styles: [__webpack_require__(34)],
        providers: [
            {
                provide: forms_1.NG_VALUE_ACCESSOR,
                useExisting: core_1.forwardRef(function () { return RadioComponent_1; }),
                multi: true
            }
        ]
    })
], RadioComponent);
exports.RadioComponent = RadioComponent;
var RadioComponent_1;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "<label class=\"radio\" [class.radio--grouped]=\"grouped\" [class.radio--disabled]=\"disabled\" tabindex=\"0\">\r\n    <input [(ngModel)]=\"model\" [value]=\"value\" [name]=\"name\" [disabled]=\"disabled\" (change)=\"onChangeCallback(model)\"\r\n           class=\"radio__input\" type=\"radio\" role=\"radio\" tabindex=\"-1\">\r\n    <span class=\"radio__element\"></span>\r\n    <span class=\"radio__label\" *ngIf=\"label\">{{ label | translate }}</span>\r\n</label>"

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(35);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".radio {\n  display: flex;\n  cursor: pointer;\n  margin-bottom: 5px;\n  align-items: center; }\n  .radio--grouped {\n    margin-bottom: 20px; }\n  .radio > .radio__input {\n    display: none; }\n    .radio > .radio__input + .radio__element {\n      user-select: none;\n      position: relative; }\n      .radio > .radio__input + .radio__element:before {\n        width: 22px;\n        content: '';\n        height: 22px;\n        min-width: 22px;\n        min-height: 22px;\n        border-radius: 50%;\n        vertical-align: top;\n        display: inline-block;\n        border: 1px solid #bdc4c9;\n        background-color: #ffffff; }\n      .radio > .radio__input + .radio__element:after {\n        top: 4px;\n        left: 4px;\n        opacity: 0;\n        width: 14px;\n        content: '';\n        height: 14px;\n        display: block;\n        min-width: 14px;\n        min-height: 14px;\n        position: absolute;\n        border-radius: 50%;\n        transform: scale(0.5);\n        background-color: #4caf50;\n        will-change: transform, opacity;\n        transition: opacity 0.3s cubic-bezier(0.2, 0.3, 0, 1), transform 0.3s cubic-bezier(0.2, 0.3, 0, 1); }\n    .radio > .radio__input:checked + .radio__element:before {\n      background-color: #ffffff;\n      border-color: #4caf50; }\n    .radio > .radio__input:checked + .radio__element:after {\n      opacity: 1;\n      transform: scale(1); }\n  .radio > .radio__label {\n    font-weight: 400;\n    margin-left: 10px;\n    display: inline-block; }\n  .radio--disabled {\n    cursor: default;\n    pointer-events: none; }\n    .radio--disabled > .radio__input + .radio__element:after {\n      background-color: rgba(204, 204, 204, 0.64); }\n    .radio--disabled > .radio__input:checked + .radio__element:before {\n      border-color: rgba(204, 204, 204, 0.64); }\n  .radio:focus > .radio__input + .radio__element:before {\n    box-shadow: 0 0 0 2px rgba(3, 102, 214, 0.1); }\n", ""]);

// exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = __webpack_require__(2);
var core_1 = __webpack_require__(0);
var SelectComponent = SelectComponent_1 = (function () {
    function SelectComponent() {
        this.grouped = true;
        this.multiple = false;
        this.disabled = false;
        this.reversed = false;
        // Callbacks.
        this.onTouchedCallback = function () {
        };
        this.onChangeCallback = function () {
        };
    }
    /**
     * Saves the new value.
     *
     * @param {boolean} value The new value of the select.
     */
    SelectComponent.prototype.writeValue = function (value) {
        if (this.result !== value) {
            this.result = value;
        }
    };
    /**
     * Registers a change in the input.
     *
     * @param {(_: boolean) => void} method The onChange callback.
     */
    SelectComponent.prototype.registerOnChange = function (method) {
        this.onChangeCallback = method;
    };
    /**
     * Registers a touch.
     *
     * @param {() => void} method The touch callback.
     */
    SelectComponent.prototype.registerOnTouched = function (method) {
        this.onTouchedCallback = method;
    };
    /**
     * Triggers when the input is set to a disabled state.
     *
     * @param {boolean} isDisabled Boolean if the input is disabled.
     */
    SelectComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return SelectComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectComponent.prototype, "icon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectComponent.prototype, "label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SelectComponent.prototype, "grouped", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SelectComponent.prototype, "multiple", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SelectComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SelectComponent.prototype, "reversed", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], SelectComponent.prototype, "items", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectComponent.prototype, "result", void 0);
SelectComponent = SelectComponent_1 = __decorate([
    core_1.Component({
        selector: 'bb-select',
        template: __webpack_require__(37),
        styles: [__webpack_require__(38)],
        providers: [
            {
                provide: forms_1.NG_VALUE_ACCESSOR,
                useExisting: core_1.forwardRef(function () { return SelectComponent_1; }),
                multi: true
            }
        ]
    })
], SelectComponent);
exports.SelectComponent = SelectComponent;
var SelectComponent_1;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = "<bb-form-control [grouped]=\"grouped\" [label]=\"label\" [icon]=\"icon\" [reversed]=\"reversed\">\r\n    <ng-select [disabled]=\"disabled\" [options]=\"items\" [allowClear]=\"true\" [(ngModel)]=\"result\" [noFilter]=\"5\"\r\n               [multiple]=\"multiple\" (ngModelChange)=\"onChangeCallback(result)\"\r\n               [placeholder]=\"'Click to select an item from the list' | translate\"\r\n               [notFoundMsg]=\"'No item was found' | translate\"\r\n               [filterPlaceholder]=\"'Search for items in the list' | translate\">\r\n    </ng-select>\r\n</bb-form-control>"

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(39);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ":host {\n  width: 100%; }\n\n:host /deep/ ng-select {\n  width: 100%;\n  height: 34px;\n  min-width: 80px;\n  position: relative;\n  border-radius: 3px;\n  border: 1px solid #bdc4c9;\n  background-color: transparent; }\n  :host /deep/ ng-select > div {\n    border: none !important;\n    height: 34px !important; }\n    :host /deep/ ng-select > div > div.single {\n      height: 32px !important; }\n      :host /deep/ ng-select > div > div.single > div.placeholder {\n        color: #aaaaaa !important; }\n      :host /deep/ ng-select > div > div.single > div.placeholder, :host /deep/ ng-select > div > div.single > div.toggle, :host /deep/ ng-select > div > div.single > div.clear, :host /deep/ ng-select > div > div.single > div.value {\n        color: #3d464d;\n        line-height: 34px !important; }\n    :host /deep/ ng-select > div > div.multiple {\n      height: auto !important;\n      min-height: 32px !important; }\n      :host /deep/ ng-select > div > div.multiple > input {\n        height: 32px;\n        box-shadow: none;\n        line-height: 32px; }\n      :host /deep/ ng-select > div > div.multiple > div.placeholder {\n        color: #aaaaaa !important; }\n      :host /deep/ ng-select > div > div.multiple > div.placeholder, :host /deep/ ng-select > div > div.multiple > div.toggle, :host /deep/ ng-select > div > div.multiple > div.clear, :host /deep/ ng-select > div > div.multiple > div.value {\n        color: #3d464d; }\n\n:host /deep/ select-dropdown > div {\n  top: 46px;\n  border-radius: 3px;\n  border: 1px solid #bdc4c9; }\n  :host /deep/ select-dropdown > div input:focus {\n    box-shadow: none !important; }\n  :host /deep/ select-dropdown > div > div.options {\n    border-radius: 2px; }\n    :host /deep/ select-dropdown > div > div.options ul {\n      border-radius: 2px; }\n      :host /deep/ select-dropdown > div > div.options ul > li:first-child {\n        border-top-left-radius: 2px;\n        border-top-right-radius: 2px; }\n      :host /deep/ select-dropdown > div > div.options ul > li:last-child {\n        border-bottom-left-radius: 2px;\n        border-bottom-right-radius: 2px; }\n", ""]);

// exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ButtonComponent = (function () {
    function ButtonComponent() {
        /**
         * The loading state of the button.
         * @type {boolean}
         */
        this.loading = false;
        /**
         * The disabled state of the button.
         * @type {boolean}
         */
        this.disabled = false;
        /**
         * The reversed state of the button.
         * @type {boolean}
         */
        this.reversed = false;
        /**
         * The grouped state of the button.
         * @type {boolean}
         */
        this.grouped = false;
        /**
         * The type of the button.
         * @type {string}
         */
        this.type = 'button';
        /**
         * The color of the button.
         * @type {string}
         */
        this.color = 'blue';
    }
    return ButtonComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ButtonComponent.prototype, "text", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ButtonComponent.prototype, "icon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "loading", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "reversed", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "grouped", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "type", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "color", void 0);
ButtonComponent = __decorate([
    core_1.Component({
        selector: 'bb-button',
        styles: [__webpack_require__(41)],
        template: __webpack_require__(43)
    })
], ButtonComponent);
exports.ButtonComponent = ButtonComponent;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(42);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".button {\n  padding: 0;\n  width: auto;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  user-select: none;\n  position: relative;\n  text-align: center;\n  border-radius: 3px;\n  align-items: center;\n  display: inline-flex;\n  text-decoration: none;\n  justify-content: center;\n  border: 1px solid #0c6ebe;\n  box-shadow: 0 0 0 0 transparent;\n  background: #007ee5 linear-gradient(#168add, #007ee5);\n  transition: background 300ms cubic-bezier(0, 0, 0.2, 1), padding-left 300ms cubic-bezier(0, 0, 0.2, 1), box-shadow 300ms cubic-bezier(0, 0, 0.2, 1); }\n  .button::before, .button::after {\n    content: '';\n    flex: 1 0 auto; }\n  .button:active {\n    background: linear-gradient(#1b80d3, #0a74cb); }\n  .button:hover {\n    background: linear-gradient(#168eef, #007ee5); }\n  .button:focus {\n    box-shadow: 0 0 0 2px #a0d1fa; }\n  .button__text {\n    width: 100%;\n    padding: 8px 12px;\n    text-align: center;\n    align-items: center;\n    display: inline-flex;\n    justify-content: center; }\n  .button__icon {\n    width: 32px;\n    height: 32px;\n    display: flex;\n    min-width: 32px;\n    min-height: 32px;\n    align-items: center;\n    justify-content: center; }\n    .button__icon + .button__text {\n      border-color: #2265d4;\n      border-left: 1px solid rgba(0, 0, 0, 0.2); }\n  .button > svg {\n    left: 2px;\n    opacity: 0;\n    position: absolute;\n    will-change: opacity;\n    top: calc(50% - 16px);\n    transition: opacity 100ms cubic-bezier(0, 0, 0.2, 1); }\n  .button--reversed {\n    flex-direction: row-reverse; }\n    .button--reversed .button__icon + .button__text {\n      border-right: 1px solid rgba(0, 0, 0, 0.2);\n      border-left: none; }\n  .button--loading {\n    padding-left: 30px; }\n    .button--loading > svg {\n      opacity: 1; }\n  .button:disabled, .button--loading {\n    opacity: 0.4;\n    cursor: default;\n    pointer-events: none; }\n  .button--grouped {\n    margin-bottom: 20px; }\n  .button--default {\n    color: #2895F1;\n    background: transparent;\n    border: 1px solid transparent; }\n    .button--default:active {\n      background: transparent; }\n    .button--default:hover {\n      text-decoration: underline;\n      background: transparent; }\n    .button--default:focus {\n      box-shadow: 0 0 0 0 transparent; }\n    .button--default__icon .button__text {\n      border-color: transparent; }\n  .button--green {\n    border: 1px solid #388e3c;\n    background: #43a047 linear-gradient(#4caf50, #43a047); }\n    .button--green:active {\n      background: linear-gradient(#449c47, #3c8f3f); }\n    .button--green:hover {\n      background: linear-gradient(#48a64c, #3d9141); }\n    .button--green:focus {\n      box-shadow: 0 0 0 2px rgba(75, 166, 66, 0.4); }\n    .button--green__icon .button__text {\n      border-color: #2e6e31; }\n  .button--red {\n    border: 1px solid #941414;\n    background: #be2c2c linear-gradient(#ca2d2d, #be2c2c); }\n    .button--red:active {\n      background: linear-gradient(#be2a2a, #a82626); }\n    .button--red:hover {\n      background: linear-gradient(#b82929, #b02727); }\n    .button--red:focus {\n      box-shadow: 0 0 0 2px rgba(211, 47, 47, 0.4); }\n    .button--red__icon .button__text {\n      border-color: #bf2d2d; }\n", ""]);

// exports


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = "<button [attr.type]=\"type\" [disabled]=\"disabled\" class=\"button {{ 'button--' + color }}\"\r\n        [ngClass]=\"{'button--loading': loading, 'button--reversed': reversed, 'button--grouped': grouped}\">\r\n    <svg width=\"32px\" height=\"32px\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"\r\n         preserveAspectRatio=\"xMidYMid\" class=\"lds-ring\">\r\n        <circle cx=\"50\" cy=\"50\" r=\"30\" stroke-width=\"10\" fill=\"none\"></circle>\r\n        <circle cx=\"50\" cy=\"50\" r=\"30\" stroke=\"#ffffff\" stroke-width=\"10\" fill=\"none\" transform=\"rotate(144 50 50)\">\r\n            <animateTransform attributeName=\"transform\" type=\"rotate\" calcMode=\"linear\" values=\"0 50 50;360 50 50\"\r\n                              keyTimes=\"0;1\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\"></animateTransform>\r\n            <animate attributeName=\"stroke-dasharray\" calcMode=\"linear\"\r\n                     values=\"18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882\"\r\n                     keyTimes=\"0;0.5;1\" dur=\"1\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\r\n        </circle>\r\n    </svg>\r\n\r\n    <i class=\"material-icons button__icon\" *ngIf=\"icon\">{{ icon }}</i>\r\n\r\n    <span class=\"button__text\" *ngIf=\"text\">{{ text | translate }}</span>\r\n</button>"

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ButtonGroupComponent = (function () {
    function ButtonGroupComponent() {
        /**
         * The type of the button-group (left|right).
         * @type {string}
         */
        this.type = 'left';
        /**
         * If the button group should take the full width.
         * @type {boolean}
         */
        this.full = false;
    }
    return ButtonGroupComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ButtonGroupComponent.prototype, "type", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ButtonGroupComponent.prototype, "full", void 0);
ButtonGroupComponent = __decorate([
    core_1.Component({
        selector: 'bb-button-group',
        styles: [__webpack_require__(45)],
        template: __webpack_require__(47)
    })
], ButtonGroupComponent);
exports.ButtonGroupComponent = ButtonGroupComponent;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(46);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".button-group {\n  display: flex;\n  flex-direction: column; }\n  .button-group--left {\n    justify-content: flex-start; }\n  .button-group--right {\n    justify-content: flex-end; }\n\n:host /deep/ .button-group--full bb-button, :host /deep/ .button-group--full .button {\n  width: 100%; }\n\n:host /deep/ bb-button:not(:first-child) {\n  margin-top: 5px; }\n\n@media only screen and (min-width: 768px) {\n  .button-group {\n    flex-direction: row; }\n  :host /deep/ bb-button:not(:first-child) {\n    margin-top: 0;\n    margin-left: 5px; } }\n", ""]);

// exports


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = "<div class=\"button-group {{ 'button-group--' + type }} {{ full ? 'button-group--full' : ''}}\">\r\n    <ng-content></ng-content>\r\n</div>"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var CardComponent = (function () {
    function CardComponent() {
        this.overflow = 0;
        // Outputs.
        this.onButtonClicked = new core_1.EventEmitter();
    }
    /**
     * Gets triggered when a button is clicked. It emits a button click.
     *
     * @param {CardButton} button The button that is clicked.
     */
    CardComponent.prototype.onButtonClick = function (button) {
        this.onButtonClicked.emit({ id: button.id });
    };
    return CardComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CardComponent.prototype, "title", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CardComponent.prototype, "padding", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CardComponent.prototype, "overflow", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CardComponent.prototype, "leftButtonBar", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], CardComponent.prototype, "rightButtonBar", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], CardComponent.prototype, "onButtonClicked", void 0);
CardComponent = __decorate([
    core_1.Component({
        selector: 'bb-card',
        template: __webpack_require__(49),
        styles: [__webpack_require__(50)]
    })
], CardComponent);
exports.CardComponent = CardComponent;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card\">\r\n    <div class=\"card-header\" *ngIf=\"title || leftButtonBar || rightButtonBar\">\r\n        <div class=\"card-header__items card-header__items--left\" *ngIf=\"leftButtonBar\">\r\n            <button class=\"card-header__button\" *ngFor=\"let button of leftButtonBar\" (click)=\"onButtonClick(button)\">\r\n                <i class=\"material-icons\">{{ button.icon }}</i>\r\n            </button>\r\n        </div>\r\n        <span class=\"card-header__title\"><ng-container *ngIf=\"title\">{{ title | translate }}</ng-container></span>\r\n        <div class=\"card-header__items card-header__items--right\" *ngIf=\"rightButtonBar\">\r\n            <button class=\"card-header__button\" *ngFor=\"let button of rightButtonBar\" (click)=\"onButtonClick(button)\">\r\n                <i class=\"material-icons\">{{ button.icon }}</i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <div class=\"card-body\" [ngClass]=\"{'card-body--overflow': overflow !== 0}\" [style.padding]=\"padding\"\r\n         [style.height]=\"overflow === 0 ? 'auto': overflow + 'px'\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>"

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(51);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".card {\n  border-radius: 4px;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); }\n\n.card-header {\n  height: 50px;\n  display: flex;\n  padding: 0 20px;\n  position: relative;\n  background-color: #ffffff;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom: 1px solid #d0d4d9; }\n  .card-header__title, .card-header__button {\n    color: #6a788d; }\n  .card-header__title {\n    flex: 1;\n    font-size: 17px;\n    max-width: 100%;\n    overflow: hidden;\n    font-weight: 500;\n    line-height: 46px;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n  .card-header__items {\n    display: flex;\n    align-items: center;\n    margin-right: -13px; }\n    .card-header__items--right > .card-header__button:first-child {\n      margin-left: 5px; }\n    .card-header__items--left {\n      margin-right: 0;\n      margin-left: -13px; }\n      .card-header__items--left > .card-header__button {\n        margin-left: 0; }\n        .card-header__items--left > .card-header__button:last-child {\n          margin-right: 5px; }\n  .card-header__button {\n    width: 38px;\n    height: 38px;\n    border: none;\n    display: flex;\n    border-radius: 50%;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    transition: color 150ms cubic-bezier(0, 0, 0.2, 1), background-color 150ms cubic-bezier(0, 0, 0.2, 1); }\n    .card-header__button:hover {\n      color: #000000;\n      background-color: rgba(0, 0, 0, 0.1); }\n\n.card-body {\n  padding: 20px;\n  background-color: #f6f9fc;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px; }\n  .card-body--overflow {\n    overflow-y: auto; }\n", ""]);

// exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(14);
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(5);
var common_1 = __webpack_require__(3);
var router_1 = __webpack_require__(53);
__webpack_require__(15);
var ModalComponent = (function () {
    function ModalComponent(router, location) {
        this.router = router;
        this.location = location;
        this.initial = false;
        this.state = 'inactive';
        this.wrapperState = 'active';
        // Inputs.
        this.out = true;
        this.overflow = true;
        this.boilerplate = true;
        // Outputs.
        this.onButtonClicked = new core_1.EventEmitter();
    }
    ModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.wait) {
            this.wait.first().subscribe(function () {
                _this.state = 'active';
                _this.initial = true;
            });
        }
        else {
            this.state = 'active';
            this.initial = true;
        }
    };
    ModalComponent.prototype.onClickOutside = function (event) {
        if (event
            && event['value'] === true
            && typeof event['target'].className === 'string'
            && event['target'].className.includes('modal__wrapper')
            && this.out) {
            this.quit();
        }
    };
    ModalComponent.prototype.onClick = function (event) {
        if (event.id === 'goBackModal') {
            this.quit();
            return;
        }
        this.onButtonClicked.emit(event);
    };
    ModalComponent.prototype.animationDone = function ($event) {
        if ($event.fromState === 'void' || $event.toState !== 'inactive') {
            return;
        }
        if (this.back) {
            this.router.navigate([this.back]).then(function (_) { return _; });
            return;
        }
        this.location.back();
    };
    ModalComponent.prototype.quit = function () {
        this.state = 'inactive';
        this.wrapperState = 'inactive';
    };
    return ModalComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ModalComponent.prototype, "out", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ModalComponent.prototype, "overflow", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ModalComponent.prototype, "boilerplate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ModalComponent.prototype, "back", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ModalComponent.prototype, "title", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ModalComponent.prototype, "modifier", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Observable_1.Observable)
], ModalComponent.prototype, "wait", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ModalComponent.prototype, "leftButtonBar", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ModalComponent.prototype, "rightButtonBar", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ModalComponent.prototype, "onButtonClicked", void 0);
ModalComponent = __decorate([
    core_1.Component({
        selector: 'bb-modal',
        template: __webpack_require__(54),
        styles: [__webpack_require__(55)],
        animations: [
            animations_1.trigger('modalState', [
                animations_1.state('inactive', animations_1.style({ transform: 'scale(0.95)', opacity: 0 })),
                animations_1.state('active', animations_1.style({ transform: 'none', opacity: 1 })),
                animations_1.transition('inactive => active', animations_1.animate("220ms cubic-bezier(0.0, 0.0, 0.2, 1)")),
                animations_1.transition('active => inactive', animations_1.animate("220ms cubic-bezier(0.0, 0.0, 0.2, 1)")),
                animations_1.transition('inactive => void', [animations_1.animate(220, animations_1.style({
                        transform: 'scale(0.95)',
                        opacity: 0
                    }))]),
                animations_1.transition('void => active', [animations_1.style({
                        transform: 'scale(0.95)',
                        opacity: 0
                    }), animations_1.animate(110)])
            ]),
            animations_1.trigger('modalWrapperState', [
                animations_1.state('inactive', animations_1.style({ opacity: 0 })),
                animations_1.state('active', animations_1.style({ opacity: 1 })),
                animations_1.transition('inactive => active', animations_1.animate("220ms cubic-bezier(0.0, 0.0, 0.2, 1)")),
                animations_1.transition('active => inactive', animations_1.animate("220ms cubic-bezier(0.0, 0.0, 0.2, 1)")),
                animations_1.transition('inactive => void', [animations_1.animate(220, animations_1.style({ opacity: 0 }))]),
                animations_1.transition('void => active', [animations_1.style({ opacity: 0 }), animations_1.animate(220)])
            ])
        ]
    }),
    __metadata("design:paramtypes", [router_1.Router, common_1.Location])
], ModalComponent);
exports.ModalComponent = ModalComponent;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_53__;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "<div [@modalWrapperState]=\"wrapperState\" (@modalWrapperState.done)=\"animationDone($event)\" class=\"modal__wrapper\">\r\n    <div [@modalState]=\"state\" [class]=\"'modal modal--' + modifier\" [ngClass]=\"{'modal--overflow': overflow}\"\r\n         bbClickOutside (clickOutside)=\"onClickOutside($event)\">\r\n        <bb-card *ngIf=\"boilerplate; else data\" [title]=\"title\" [leftButtonBar]=\"leftButtonBar\"\r\n                 [rightButtonBar]=\"rightButtonBar || [{id: 'goBackModal', icon: 'clear'}]\"\r\n                 (onButtonClicked)=\"onClick($event)\">\r\n            <ng-container *ngTemplateOutlet=\"data\"></ng-container>\r\n        </bb-card>\r\n\r\n        <ng-template #data>\r\n            <ng-content></ng-content>\r\n        </ng-template>\r\n    </div>\r\n\r\n    <div *ngIf=\"state !== 'active' && !initial\"\r\n         style=\"position: fixed; top: calc(50% - 32px); left: calc(50% - 32px)\">\r\n        <svg width=\"64px\" height=\"64px\"\r\n             xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" class=\"lds-ring\">\r\n            <circle cx=\"50\" cy=\"50\" r=\"30\" stroke-width=\"10\" fill=\"none\"></circle>\r\n            <circle cx=\"50\" cy=\"50\" r=\"30\" stroke=\"#9f9f9f\" stroke-width=\"10\" fill=\"none\" transform=\"rotate(144 50 50)\">\r\n                <animateTransform attributeName=\"transform\" type=\"rotate\" calcMode=\"linear\" values=\"0 50 50;360 50 50\"\r\n                                  keyTimes=\"0;1\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\"></animateTransform>\r\n                <animate attributeName=\"stroke-dasharray\" calcMode=\"linear\"\r\n                         values=\"18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882\"\r\n                         keyTimes=\"0;0.5;1\" dur=\"1\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\r\n            </circle>\r\n        </svg>\r\n    </div>\r\n</div>"

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(56);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".modal {\n  width: 100%;\n  filter: none;\n  max-width: 750px;\n  margin: 20px auto 0;\n  will-change: transform, opacity; }\n  .modal--small {\n    max-width: 400px; }\n  .modal__wrapper {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 300;\n    padding: 20px;\n    position: fixed;\n    overflow-y: auto;\n    will-change: opacity;\n    background-color: rgba(0, 0, 0, 0.5); }\n\n:host /deep/ .card-body {\n  overflow-x: inherit; }\n\n:host /deep/ .modal--overflow .card-body {\n  overflow-y: auto;\n  max-height: calc(100vh - 170px); }\n\n@media only screen and (min-width: 768px) {\n  .modal {\n    margin: 40px auto 0; }\n    .modal__wrapper {\n      padding: 40px 20px 20px; }\n  :host /deep/ .modal--overflow .card-body {\n    max-height: calc(100vh - 210px); } }\n", ""]);

// exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(2);
var translations_service_1 = __webpack_require__(6);
var DatePickerComponent = DatePickerComponent_1 = (function () {
    function DatePickerComponent(translations) {
        this.translations = translations;
        this.visible = false;
        this.current = new Date();
        this.days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        this.months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august',
            'september', 'october', 'november', 'december'];
        /**
         * The disabled state of the date-picker.
         * @type {boolean}
         */
        this.disabled = false;
        /**
         * The placeholder identifier.
         * @type {string}
         */
        this.placeholder = 'Please select a date';
        /**
         * If the icon should be reversed.
         * @type {boolean}
         */
        this.reversed = false;
        /**
         * If the date-picker should have bottom margin.
         * @type {boolean}
         */
        this.grouped = true;
        // Callbacks.
        this.onTouchedCallback = function () {
        };
        this.onChangeCallback = function () {
        };
    }
    DatePickerComponent.prototype.ngOnInit = function () {
        // Get the calendar for the date.
        this.recalculate();
    };
    DatePickerComponent.prototype.onDayClick = function (day) {
        this.writeValue(day.date);
    };
    Object.defineProperty(DatePickerComponent.prototype, "date", {
        get: function () {
            this.value = this.value || new Date();
            var translation = this.translations.instant(this.days[this.value.getDay()]);
            var day = translation.charAt(0).toUpperCase() + translation.slice(1);
            var date = this.value.getDate();
            var year = this.value.getFullYear();
            var month = this.translations.instant(this.months[this.value.getMonth()]);
            return day + " " + date + " " + month + " " + year;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerComponent.prototype, "month", {
        get: function () {
            return this.current ? this.months[this.current.getMonth()] : '-';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerComponent.prototype, "year", {
        get: function () {
            return this.current ? this.current.getFullYear() + '' : '-';
        },
        enumerable: true,
        configurable: true
    });
    DatePickerComponent.prototype.recalculate = function (number) {
        if (number === void 0) { number = 0; }
        this.current = this.current || new Date();
        this.current.setMonth(this.current.getMonth() + number);
        this.calendar = this.getCalendar();
    };
    DatePickerComponent.prototype.getCalendar = function () {
        var current = this.getFirstDayOfMonth(this.current);
        var weeks = [];
        // Loop through six weeks.
        for (var index = 0; index < 6; index++) {
            // Get the week.
            var week = [];
            // Loop through seven days per week.
            for (var j = 0; j < 7; j++) {
                var weekDate = new Date(current);
                week.push({
                    date: weekDate,
                    number: weekDate.getDate(),
                    active: this.current.getMonth() === weekDate.getMonth()
                });
                current.setDate(current.getDate() + 1);
            }
            // Add the week to the total.
            weeks.push(week);
        }
        return weeks;
    };
    DatePickerComponent.prototype.getFirstDayOfMonth = function (date) {
        if (date === void 0) { date = null; }
        var current = date ? new Date(date) : new Date();
        var year = current.getFullYear();
        var month = current.getMonth();
        // Get the first day of the month.
        var firstDayOfMonth = new Date(year, month, 1);
        // Get the first day of the week
        return this.getFirstDayOfWeek(firstDayOfMonth);
    };
    DatePickerComponent.prototype.getFirstDayOfWeek = function (current) {
        var date = new Date(current);
        var dayOfWeek = date.getDay();
        var diff = date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        return new Date(date.setDate(diff));
    };
    /**
     * Handle for when the user clicks outside the drop-down area.
     *
     * @param event The event containing if the click was outside.
     */
    DatePickerComponent.prototype.onClickOutside = function (event) {
        var isDatePicker = typeof event['target'].className === 'string'
            && !event['target'].className.includes('input--date-picker--bb');
        if (event && event['value'] === true && isDatePicker) {
            this.toggle(false);
        }
    };
    /**
     * Toggles the dropdown menu with a given value.
     *
     * @param value A boolean.
     */
    DatePickerComponent.prototype.toggle = function (value) {
        this.visible = value;
    };
    DatePickerComponent.prototype.onHost = function () {
        this.toggle(true);
    };
    /**
     * Saves the new value.
     *
     * @param {Date} value The new value of the checkbox.
     */
    DatePickerComponent.prototype.writeValue = function (value) {
        if (this.value !== value) {
            this.value = value;
        }
    };
    /**
     * Registers a change in the input.
     *
     * @param {(_: Date) => void} method The onChange callback.
     */
    DatePickerComponent.prototype.registerOnChange = function (method) {
        this.onChangeCallback = method;
    };
    /**
     * Registers a touch.
     *
     * @param {() => void} method The touch callback.
     */
    DatePickerComponent.prototype.registerOnTouched = function (method) {
        this.onTouchedCallback = method;
    };
    /**
     * Triggers when the input is set to a disabled state.
     *
     * @param {boolean} isDisabled Boolean if the input is disabled.
     */
    DatePickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return DatePickerComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Date)
], DatePickerComponent.prototype, "value", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatePickerComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePickerComponent.prototype, "icon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatePickerComponent.prototype, "placeholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePickerComponent.prototype, "label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatePickerComponent.prototype, "reversed", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatePickerComponent.prototype, "grouped", void 0);
__decorate([
    core_1.HostListener('click', ['$event.target']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DatePickerComponent.prototype, "onHost", null);
DatePickerComponent = DatePickerComponent_1 = __decorate([
    core_1.Component({
        selector: 'bb-date-picker',
        styles: [__webpack_require__(58)],
        template: __webpack_require__(60),
        providers: [
            {
                provide: forms_1.NG_VALUE_ACCESSOR,
                useExisting: core_1.forwardRef(function () { return DatePickerComponent_1; }),
                multi: true
            }
        ]
    }),
    __metadata("design:paramtypes", [translations_service_1.TranslationsService])
], DatePickerComponent);
exports.DatePickerComponent = DatePickerComponent;
var DatePickerComponent_1;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(59);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ":host {\n  position: relative; }\n\n:host /deep/ .dropdown {\n  left: 0;\n  top: 100%;\n  opacity: 0;\n  width: 100%;\n  z-index: 1000;\n  min-width: 250px;\n  position: absolute;\n  border-radius: 4px;\n  pointer-events: none;\n  transform: translateY(0);\n  background-color: #ffffff;\n  border: 1px solid #bdc4c9;\n  will-change: opacity, transform;\n  transition: transform 150ms cubic-bezier(0, 0, 0.2, 1), opacity 200ms cubic-bezier(0, 0, 0.2, 1); }\n  :host /deep/ .dropdown:after, :host /deep/ .dropdown:before {\n    width: 0;\n    left: 50%;\n    height: 0;\n    content: '';\n    bottom: 100%;\n    position: absolute;\n    pointer-events: none;\n    border: solid transparent; }\n  :host /deep/ .dropdown:after {\n    border-color: rgba(136, 183, 213, 0);\n    border-bottom-color: #ffffff;\n    border-width: 10px;\n    margin-left: -10px; }\n  :host /deep/ .dropdown:before {\n    border-color: rgba(194, 225, 245, 0);\n    border-bottom-color: #bdc4c9;\n    border-width: 11px;\n    margin-left: -11px; }\n  :host /deep/ .dropdown--visible {\n    opacity: 1;\n    transform: none;\n    pointer-events: auto; }\n  :host /deep/ .dropdown__header {\n    display: flex;\n    padding: 12px 0;\n    align-items: center;\n    background-color: #ffffff;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    border-bottom: 1px solid #d0d4d9; }\n  :host /deep/ .dropdown__title {\n    flex: 1;\n    display: flex;\n    font-size: 15px;\n    text-align: center;\n    flex-direction: column; }\n    :host /deep/ .dropdown__title--first {\n      font-weight: 500;\n      text-transform: capitalize; }\n    :host /deep/ .dropdown__title--second {\n      margin-top: 2px; }\n  :host /deep/ .dropdown__button {\n    border: none;\n    background-color: transparent; }\n  :host /deep/ .dropdown__body {\n    background-color: #f6f9fc;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px; }\n  :host /deep/ .dropdown__span {\n    padding: 8px 0;\n    display: block; }\n    :host /deep/ .dropdown__span--active {\n      margin: 3px;\n      padding: 5px;\n      display: flex;\n      color: #ffffff;\n      border-radius: 50%;\n      align-items: center;\n      justify-content: center;\n      background-color: #3d9141; }\n  :host /deep/ .dropdown__row {\n    display: flex; }\n    :host /deep/ .dropdown__row:not(:last-child) {\n      border-bottom: 1px solid #d0d4d9; }\n  :host /deep/ .dropdown__item {\n    flex: 1;\n    padding: 0;\n    border: none;\n    text-align: center;\n    background-color: transparent; }\n    :host /deep/ .dropdown__item--inactive {\n      color: #b8b8b8;\n      background-color: #e6e8eb; }\n    :host /deep/ .dropdown__item:not(:last-child) {\n      border-right: 1px solid #d0d4d9; }\n", ""]);

// exports


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "<bb-form-control [label]=\"label\" [icon]=\"icon\" [reversed]=\"reversed\" [grouped]=\"grouped\">\n    <input [disabled]=\"disabled\" (click)=\"toggle(true)\" readonly type=\"text\" class=\"input--date-picker--bb\"\n           [placeholder]=\"placeholder | translate\" [(ngModel)]=\"value\" (ngModelChange)=\"recalculate()\">\n</bb-form-control>\n\n<div bbClickOutside (clickOutside)=\"onClickOutside($event)\" [ngClass]=\"{'dropdown--visible': visible}\"\n     class=\"dropdown\">\n    <div class=\"dropdown__header\">\n        <button (click)=\"recalculate(-1)\" type=\"button\" class=\"dropdown__button\">\n            <i class=\"material-icons\">chevron_left</i>\n        </button>\n        <div class=\"dropdown__title\">\n            <span class=\"dropdown__title--first\">{{ month | translate }}</span>\n            <span class=\"dropdown__title--second\">{{ year }}</span>\n        </div>\n        <button (click)=\"recalculate(1)\" type=\"button\" class=\"dropdown__button\">\n            <i class=\"material-icons\">chevron_right</i>\n        </button>\n    </div>\n    <div class=\"dropdown__body\">\n        <div class=\"dropdown__row\" *ngFor=\"let week of calendar\">\n            <button *ngFor=\"let day of week\" (click)=\"onDayClick(day)\" type=\"button\" class=\"dropdown__item\"\n                    [ngClass]=\"{'dropdown__item--inactive': !day.active}\">\n                <span class=\"dropdown__span\" [ngClass]=\"{'dropdown__span--active': value === day.date}\">\n                    {{ day.number }}\n                </span>\n            </button>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(5);
var TableComponent = (function () {
    function TableComponent() {
        // Inputs.
        this.title = null;
        this.rowIdentifier = null;
        this.rows = [];
        this.data = null;
        this.rightButtonBar = [];
        this.selectedButtonBar = [];
        this.empty = 'This list is empty.';
        this.header = true;
        this.overflow = 0;
        // Selected keys.
        this.selected = [];
        // Outputs.
        this.onButtonClicked = new core_1.EventEmitter();
        this.onSelectedChange = new core_1.EventEmitter();
    }
    /**
     * Resets the checkboxes and emits a card event.
     *
     * @param {CardEvent} event The incoming card event.
     */
    TableComponent.prototype.resetAndEmit = function (event) {
        this.onButtonClicked.emit(__assign({}, event, { data: this.selected.slice() }));
        this.selected.length = 0;
        this.onSelectedChange.emit(this.selected.slice());
    };
    /**
     * Handles the all checkbox clicked.
     *
     * @param {object[]} list The list of objects.
     */
    TableComponent.prototype.onAllCheckboxClicked = function (list) {
        var _this = this;
        this.selected.length === list.length ?
            this.selected.length = 0 :
            this.selected = list.map(function (item) { return item[_this.rowIdentifier]; });
        this.onSelectedChange.emit(this.selected.slice());
    };
    /**
     * Handles the default checkbox clicked.
     *
     * @param {string} identifier The identifier of the item.
     */
    TableComponent.prototype.onCheckboxClicked = function (identifier) {
        var index = this.selected.indexOf(identifier);
        index >= 0 ?
            this.selected.splice(index, 1) :
            this.selected.push(identifier);
        this.onSelectedChange.emit(this.selected.slice());
    };
    /**
     * Checks if the row is selected.
     *
     * @param {string} identifier The identifier of the item.
     *
     * @returns {boolean} If the row checkbox is selected.
     */
    TableComponent.prototype.isRowSelected = function (identifier) {
        return this.selected.indexOf(identifier) >= 0;
    };
    Object.defineProperty(TableComponent.prototype, "buttonBar", {
        /**
         * @returns {CardButton[]} The current button bar.
         */
        get: function () {
            return this.selected.length === 0 ?
                this.rightButtonBar :
                this.rightButtonBar.concat(this.selectedButtonBar);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Angular loop optimizations.
     *
     * @param {number} index The index of the item.
     * @param {object} item The item.
     *
     * @returns {number} The unique identifier.
     */
    TableComponent.prototype.trackByRowIdentifier = function (index, item) {
        return item[this.rowIdentifier];
    };
    /**
     * Angular loop optimizations.
     *
     * @param {number} index The index of the item.
     * @param {TableRow} row The table row.
     *
     * @returns {number} The unique identifier.
     */
    TableComponent.prototype.trackByRow = function (index, row) {
        return row.label + index;
    };
    return TableComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TableComponent.prototype, "title", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TableComponent.prototype, "rowIdentifier", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TableComponent.prototype, "rows", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Observable_1.Observable)
], TableComponent.prototype, "data", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TableComponent.prototype, "rightButtonBar", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TableComponent.prototype, "selectedButtonBar", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TableComponent.prototype, "empty", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], TableComponent.prototype, "header", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], TableComponent.prototype, "overflow", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TableComponent.prototype, "selected", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], TableComponent.prototype, "onButtonClicked", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], TableComponent.prototype, "onSelectedChange", void 0);
TableComponent = __decorate([
    core_1.Component({
        selector: 'bb-table',
        template: __webpack_require__(62),
        styles: [__webpack_require__(63)]
    })
], TableComponent);
exports.TableComponent = TableComponent;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = "<bb-card [padding]=\"0\" [title]=\"title\" [rightButtonBar]=\"buttonBar\" [overflow]=\"overflow\"\r\n         (onButtonClicked)=\"resetAndEmit($event)\">\r\n    <div class=\"table-wrapper\">\r\n        <table class=\"table\">\r\n            <ng-container *ngIf=\"data | async as list; else loading\">\r\n                <tr *ngIf=\"header && list.length > 0\" class=\"table-row table-row--header\">\r\n                    <th *ngIf=\"selectedButtonBar.length > 0\" class=\"table-header table-header__checkbox\">\r\n                        <bb-checkbox (click)=\"onAllCheckboxClicked(list)\" [selected]=\"selected.length === list.length\"\r\n                                     [single]=\"true\"></bb-checkbox>\r\n                    </th>\r\n                    <th *ngFor=\"let row of rows; trackBy: trackByRow\" [ngClass]=\"{\r\n                        'table-header--fit': row.fit,\r\n                        'table-header--center': row.flow === 'center',\r\n                        'table-header--left': !row.flow || row.flow === 'left',\r\n                        'table-header--right': row.flow === 'right'\r\n                    }\" class=\"table-header\">\r\n                        {{ row.label && row.label !== '' ? (row.label | translate) : row.label }}\r\n                    </th>\r\n                </tr>\r\n                <tr class=\"table-row\" *ngFor=\"let item of list; trackBy: trackByRowIdentifier\">\r\n                    <td *ngIf=\"selectedButtonBar.length > 0\" class=\"table-data table-data__checkbox\">\r\n                        <bb-checkbox (click)=\"onCheckboxClicked(item[rowIdentifier])\"\r\n                                     [selected]=\"isRowSelected(item[rowIdentifier])\" [single]=\"true\"></bb-checkbox>\r\n                    </td>\r\n                    <td *ngFor=\"let row of rows; trackBy: trackByRow\" [ngClass]=\"{\r\n                        'table-data--fit': row.fit,\r\n                        'table-data--center': row.flow === 'center',\r\n                        'table-data--left': !row.flow || row.flow === 'left',\r\n                        'table-data--right': row.flow === 'right'\r\n                    }\" class=\"table-data\">\r\n                        <ng-container *ngIf=\"!row.templateRef\">\r\n                            {{ item[row.property] || '-' }}\r\n                        </ng-container>\r\n                        <ng-container *ngIf=\"row.templateRef\">\r\n                            <ng-container *ngTemplateOutlet=\"row.templateRef; context: {$implicit: {}, data: item}\">\r\n                            </ng-container>\r\n                        </ng-container>\r\n                    </td>\r\n                </tr>\r\n                <tr *ngIf=\"list.length === 0\" class=\"table-row\">\r\n                    <td class=\"table-data table-data--center table-data--empty\">\r\n                        <span class=\"light\">{{ empty | translate }}</span>\r\n                    </td>\r\n                </tr>\r\n            </ng-container>\r\n        </table>\r\n    </div>\r\n</bb-card>\r\n\r\n<ng-template #loading>\r\n    <tr class=\"table-row\">\r\n        <td class=\"table-data table-data--center\">\r\n            <svg width=\"64px\" height=\"64px\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"\r\n                 preserveAspectRatio=\"xMidYMid\" class=\"lds-ring\">\r\n                <circle cx=\"50\" cy=\"50\" r=\"30\" stroke-width=\"10\" fill=\"none\"></circle>\r\n                <circle cx=\"50\" cy=\"50\" r=\"30\" stroke=\"#9f9f9f\" stroke-width=\"10\" fill=\"none\"\r\n                        transform=\"rotate(144 50 50)\">\r\n                    <animateTransform attributeName=\"transform\" type=\"rotate\" calcMode=\"linear\"\r\n                                      values=\"0 50 50;360 50 50\"\r\n                                      keyTimes=\"0;1\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\"></animateTransform>\r\n                    <animate attributeName=\"stroke-dasharray\" calcMode=\"linear\"\r\n                             values=\"18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882\"\r\n                             keyTimes=\"0;0.5;1\" dur=\"1\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\r\n                </circle>\r\n            </svg>\r\n        </td>\r\n    </tr>\r\n</ng-template>"

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(64);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".table-wrapper {\n  overflow-x: auto; }\n\n.table {\n  width: 100%; }\n\n.table-row:not(:last-child) {\n  border-bottom: 1px solid rgba(208, 212, 217, 0.5); }\n\n.table-row:nth-child(even) {\n  background-color: rgba(0, 0, 0, 0.01); }\n\n.table-row--header {\n  background-color: #ffffff; }\n  .table-row--header:not(:last-child) {\n    border-bottom: 1px solid #d0d4d9; }\n\n.table-header, .table-data {\n  font-size: 15px;\n  padding: 14px 20px;\n  vertical-align: middle;\n  line-height: 1.2;\n  word-wrap: break-word; }\n\n.table-header__checkbox, .table-data__checkbox {\n  padding-right: 0;\n  width: 1%;\n  white-space: nowrap; }\n\n.table-header, .table-data {\n  font-weight: 500; }\n  .table-header--fit, .table-data--fit {\n    width: 1%;\n    white-space: nowrap; }\n  .table-header--left, .table-data--left {\n    text-align: left; }\n  .table-header--center, .table-data--center {\n    text-align: center; }\n  .table-header--right, .table-data--right {\n    text-align: right; }\n\n.table-header {\n  color: #afafaf; }\n\n.table-data--empty {\n  padding: 24px 20px; }\n\n:host /deep/ .table *.light {\n  color: #bebebe; }\n\n:host /deep/ .table *.subtitle {\n  margin-top: 5px; }\n\n:host /deep/ .table *.middle {\n  display: inline-block;\n  vertical-align: middle; }\n\n:host /deep/ .table img {\n  width: 32px;\n  height: 32px;\n  display: inline-block;\n  vertical-align: middle; }\n  :host /deep/ .table img.icon {\n    margin-right: 5px; }\n", ""]);

// exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(14);
var notifications_service_1 = __webpack_require__(12);
var core_1 = __webpack_require__(0);
var NotificationsComponent = (function () {
    /**
     * Default constructor.
     *
     * @param notifications The notifications service.
     */
    function NotificationsComponent(notifications) {
        this.notifications = notifications;
    }
    /**
     * Gets triggered when the component is initialized.
     */
    NotificationsComponent.prototype.ngOnInit = function () {
        this.items$ = this.notifications.items;
    };
    /**
     * Method to optimize the Angular for-loop.
     *
     * @param index The index of the item.
     * @param item The notification item.
     *
     * @returns The id of the notification.
     */
    NotificationsComponent.prototype.trackById = function (index, item) {
        return item.id;
    };
    return NotificationsComponent;
}());
NotificationsComponent = __decorate([
    core_1.Component({
        selector: 'bb-notifications',
        template: __webpack_require__(66),
        styles: [__webpack_require__(67)],
        animations: [animations_1.trigger('listAnimation', [
                animations_1.transition('* => *', [
                    animations_1.query(':enter', animations_1.style({ opacity: 0 }), { optional: true }),
                    animations_1.query(':enter', animations_1.stagger('400ms', [
                        animations_1.animate('400ms ease-in-out', animations_1.keyframes([
                            animations_1.style({ opacity: 0, transform: 'translateY(-50%)', offset: 0 }),
                            animations_1.style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 })
                        ]))
                    ]), { optional: true }),
                    animations_1.query(':leave', animations_1.stagger('500ms', [
                        animations_1.animate('500ms ease-in-out', animations_1.keyframes([
                            animations_1.style({ height: '*', opacity: 1, transform: 'translateX(0)', offset: 0 }),
                            animations_1.style({ height: '*', opacity: 0, transform: 'translateX(-25%)', offset: 0.75 }),
                            animations_1.style({ height: 0, opacity: 0, transform: 'translateX(-25%)', offset: 1.0 })
                        ]))
                    ]), { optional: true })
                ])
            ])]
    }),
    __metadata("design:paramtypes", [notifications_service_1.NotificationsService])
], NotificationsComponent);
exports.NotificationsComponent = NotificationsComponent;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "<div class=\"notifications\" *ngIf=\"items$ | async as items\">\r\n    <div class=\"notifications__list\" [@listAnimation]=\"items.length\">\r\n        <div class=\"notifications__item-wrapper\" *ngFor=\"let item of items; trackBy: trackById\">\r\n            <div class=\"notifications__item\" [ngClass]=\"{\r\n                'notifications__item--success': item.type === 'success',\r\n                'notifications__item--error': item.type === 'error'\r\n            }\">\r\n                <i class=\"material-icons notifications__icon\">error</i>\r\n                {{ item.message | translate }}\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(68);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(undefined);
// imports


// module
exports.push([module.i, ".notifications {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 150;\n  position: fixed;\n  pointer-events: none; }\n  .notifications__list {\n    width: 100%;\n    display: block;\n    margin: 0 auto;\n    padding: 0 20px;\n    max-width: 420px;\n    position: relative; }\n  .notifications__wrapper {\n    margin: 0;\n    padding: 0; }\n  .notifications__item {\n    margin: 10px;\n    display: flex;\n    color: #ffffff;\n    font-size: 15px;\n    overflow: hidden;\n    font-weight: 500;\n    padding: 10px 12px;\n    border-radius: 4px;\n    align-items: center;\n    border: 1px solid #0c6ebe;\n    will-change: opacity, transform;\n    background: #007ee5 linear-gradient(#168add, #007ee5); }\n    .notifications__item--success {\n      border: 1px solid #388e3c;\n      background: #43a047 linear-gradient(#4caf50, #43a047); }\n    .notifications__item--error {\n      border: 1px solid #941414;\n      background: #be2c2c linear-gradient(#ca2d2d, #be2c2c); }\n  .notifications__icon {\n    font-size: 24px;\n    margin-right: 12px; }\n", ""]);

// exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var translations_service_1 = __webpack_require__(6);
var core_1 = __webpack_require__(0);
var TranslatePipe = (function () {
    /**
     * Default constructor.
     *
     * @param {TranslationsService} translations The translations service.
     */
    function TranslatePipe(translations) {
        this.translations = translations;
    }
    /**
     * Transforms the given value to the translated variant.
     *
     * @param {string} value The initial value.
     * @param {any[]} args Optional arguments (not used).
     *
     * @returns {string} The translated string.
     */
    TranslatePipe.prototype.transform = function (value, args) {
        if (!value) {
            console.warn('translate.pipe.ts :: The value was not properly received', value);
            return null;
        }
        return this.translations.instant(value);
    };
    return TranslatePipe;
}());
TranslatePipe = __decorate([
    core_1.Pipe({
        name: 'translate',
        pure: true
    }),
    __metadata("design:paramtypes", [translations_service_1.TranslationsService])
], TranslatePipe);
exports.TranslatePipe = TranslatePipe;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(5);
var ClickOutsideDirective = (function () {
    /**
     * Default constructor.
     *
     * @param element The element that the directive has been added to.
     */
    function ClickOutsideDirective(element) {
        this.element = element;
        this.listening = false;
        this.clickOutside = new core_1.EventEmitter();
    }
    /**
     * Gets triggered when the component is initialized.
     */
    ClickOutsideDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.clickSubscription = Observable_1.Observable.fromEvent(document, 'click')
            .delay(1)
            .do(function () { return _this.listening = true; })
            .subscribe(function (event) { return _this.onGlobalClick(event); });
    };
    /**
     * Get triggered when the component is destroyed.
     */
    ClickOutsideDirective.prototype.ngOnDestroy = function () {
        this.clickSubscription.unsubscribe();
    };
    /**
     * Checks a global click.
     *
     * @param event The mouse event.
     */
    ClickOutsideDirective.prototype.onGlobalClick = function (event) {
        if (event instanceof MouseEvent && this.listening === true) {
            this.clickOutside.emit({
                target: (event.target || null),
                value: !this.isDescendant(this.element.nativeElement, event.target)
            });
        }
    };
    /**
     * Checks if the node is a descendant.
     *
     * @param parent The parent element.
     * @param child The child element.
     *
     * @returns If an element is a descendant.
     */
    ClickOutsideDirective.prototype.isDescendant = function (parent, child) {
        var node = child;
        while (node !== null) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };
    return ClickOutsideDirective;
}());
__decorate([
    core_1.Output('clickOutside'),
    __metadata("design:type", core_1.EventEmitter)
], ClickOutsideDirective.prototype, "clickOutside", void 0);
ClickOutsideDirective = __decorate([
    core_1.Directive({
        selector: '[bbClickOutside]'
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], ClickOutsideDirective);
exports.ClickOutsideDirective = ClickOutsideDirective;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(7));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var animations_1 = __webpack_require__(73);
var forms_1 = __webpack_require__(2);
var common_1 = __webpack_require__(3);
var ngx_cookie_1 = __webpack_require__(9);
var ng_select_1 = __webpack_require__(74);
var components_1 = __webpack_require__(13);
var services_1 = __webpack_require__(8);
var directives_1 = __webpack_require__(17);
var pipes_1 = __webpack_require__(16);
var library_config_interface_1 = __webpack_require__(7);
__webpack_require__(83);
__webpack_require__(84);
__webpack_require__(85);
__webpack_require__(15);
__webpack_require__(86);
var NgxManagerModule = NgxManagerModule_1 = (function () {
    function NgxManagerModule(parentModule) {
        if (parentModule) {
            throw new Error('NgxManagerModule is already loaded. Import it in the AppModule only');
        }
    }
    NgxManagerModule.forRoot = function (config) {
        return {
            ngModule: NgxManagerModule_1,
            providers: [
                { provide: library_config_interface_1.LibraryConfig, useValue: config }
            ]
        };
    };
    return NgxManagerModule;
}());
NgxManagerModule = NgxManagerModule_1 = __decorate([
    core_1.NgModule({
        declarations: [
            // Components.
            components_1.FormControlComponent,
            components_1.CheckboxComponent,
            components_1.RadioComponent,
            components_1.SelectComponent,
            components_1.ButtonComponent,
            components_1.ButtonGroupComponent,
            components_1.CardComponent,
            components_1.ModalComponent,
            components_1.DatePickerComponent,
            components_1.TableComponent,
            components_1.NotificationsComponent,
            // Directives.
            directives_1.ClickOutsideDirective,
            // Pipes.
            pipes_1.TranslatePipe
        ],
        imports: [
            common_1.CommonModule,
            forms_1.FormsModule,
            animations_1.BrowserAnimationsModule,
            forms_1.ReactiveFormsModule,
            ngx_cookie_1.CookieModule.forRoot(),
            ng_select_1.SelectModule
        ],
        providers: [
            services_1.TranslationsService,
            services_1.NotificationsService
        ],
        exports: [
            // Imports.
            ngx_cookie_1.CookieModule,
            // Components.
            components_1.FormControlComponent,
            components_1.CheckboxComponent,
            components_1.RadioComponent,
            components_1.SelectComponent,
            components_1.ButtonComponent,
            components_1.ButtonGroupComponent,
            components_1.CardComponent,
            components_1.ModalComponent,
            components_1.DatePickerComponent,
            components_1.TableComponent,
            components_1.NotificationsComponent,
            // Directives.
            directives_1.ClickOutsideDirective,
            // Pipes.
            pipes_1.TranslatePipe
        ]
    }),
    __param(0, core_1.Optional()), __param(0, core_1.SkipSelf()),
    __metadata("design:paramtypes", [NgxManagerModule])
], NgxManagerModule);
exports.NgxManagerModule = NgxManagerModule;
var NgxManagerModule_1;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_73__;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(3);
var forms_1 = __webpack_require__(2);
var select_component_1 = __webpack_require__(18);
var select_dropdown_component_1 = __webpack_require__(80);
__export(__webpack_require__(18));
var SelectModule = (function () {
    function SelectModule() {
    }
    SelectModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        select_component_1.SelectComponent,
                        select_dropdown_component_1.SelectDropdownComponent
                    ],
                    exports: [
                        select_component_1.SelectComponent
                    ],
                    imports: [
                        common_1.CommonModule,
                        forms_1.FormsModule
                    ]
                },] },
    ];
    /** @nocollapse */
    SelectModule.ctorParameters = function () { return []; };
    return SelectModule;
}());
exports.SelectModule = SelectModule;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLE = "ng-select {\n  display: inline-block;\n  margin: 0;\n  position: relative;\n  vertical-align: middle;\n  width: 100%; }\n  ng-select * {\n    box-sizing: border-box;\n    font-family: Sans-Serif; }\n  ng-select > div {\n    border: 1px solid #ddd;\n    box-sizing: border-box;\n    cursor: pointer;\n    user-select: none;\n    width: 100%; }\n    ng-select > div.disabled {\n      background-color: #eee;\n      color: #aaa;\n      cursor: default;\n      pointer-events: none; }\n    ng-select > div > div.single {\n      display: flex;\n      height: 30px;\n      width: 100%; }\n      ng-select > div > div.single > div.value,\n      ng-select > div > div.single > div.placeholder {\n        flex: 1;\n        line-height: 30px;\n        overflow: hidden;\n        padding: 0 10px;\n        white-space: nowrap; }\n      ng-select > div > div.single > div.placeholder {\n        color: #757575; }\n      ng-select > div > div.single > div.clear,\n      ng-select > div > div.single > div.toggle {\n        color: #aaa;\n        line-height: 30px;\n        text-align: center;\n        width: 30px; }\n        ng-select > div > div.single > div.clear:hover,\n        ng-select > div > div.single > div.toggle:hover {\n          background-color: #ececec; }\n      ng-select > div > div.single > div.clear {\n        font-size: 18px; }\n      ng-select > div > div.single > div.toggle {\n        font-size: 14px; }\n    ng-select > div > div.multiple {\n      display: flex;\n      flex-flow: row wrap;\n      height: 100%;\n      min-height: 30px;\n      padding: 0 10px;\n      width: 100%; }\n      ng-select > div > div.multiple > div.option {\n        background-color: #eee;\n        border: 1px solid #aaa;\n        border-radius: 4px;\n        color: #333;\n        cursor: default;\n        display: inline-block;\n        flex-shrink: 0;\n        font-size: 14px;\n        line-height: 22px;\n        margin: 3px 5px 3px 0;\n        padding: 0 4px; }\n        ng-select > div > div.multiple > div.option span.deselect-option {\n          color: #aaa;\n          cursor: pointer;\n          font-size: 14px;\n          height: 20px;\n          line-height: 20px; }\n          ng-select > div > div.multiple > div.option span.deselect-option:hover {\n            color: #555; }\n      ng-select > div > div.multiple input {\n        background-color: transparent;\n        border: none;\n        cursor: pointer;\n        height: 30px;\n        line-height: 30px;\n        padding: 0; }\n        ng-select > div > div.multiple input:focus {\n          outline: none; }\n  ng-select label {\n    color: rgba(0, 0, 0, 0.38);\n    display: block;\n    font-size: 13px;\n    padding: 4px 0; }\n";


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE = "<label\n    *ngIf=\"label !== ''\">\n    {{label}}\n</label>\n<div\n    #selection\n    [attr.tabindex]=\"disabled ? null : 0\"\n    [ngClass]=\"{'open': isOpen, 'focus': hasFocus, 'below': isBelow, 'disabled': disabled}\"\n    (click)=\"onSelectContainerClick($event)\"\n    (focus)=\"onSelectContainerFocus()\"\n    (keydown)=\"onSelectContainerKeydown($event)\">\n\n    <div class=\"single\"\n        *ngIf=\"!multiple\">\n        <div class=\"value\"\n            *ngIf=\"optionList.hasSelected\">\n            <ng-template [ngOutletContext]=\"{option: optionList.selection[0], onDeselectOptionClick: onDeselectOptionClick}\" [ngTemplateOutlet]=\"optionTemplate\"></ng-template>\n            <span *ngIf=\"!optionTemplate\">{{optionList.selection[0].label}}</span>\n        </div>\n        <div class=\"placeholder\"\n            *ngIf=\"!optionList.hasSelected\">\n            {{placeholderView}}\n        </div>\n        <div class=\"clear\"\n            *ngIf=\"allowClear && optionList.hasSelected\"\n            (click)=\"onClearSelectionClick($event)\">\n            &#x2715;\n        </div>\n        <div class=\"toggle\"\n            *ngIf=\"isOpen\">\n            &#x25B2;\n        </div>\n        <div class=\"toggle\"\n            *ngIf=\"!isOpen\">\n            &#x25BC;\n        </div>\n    </div>\n\n    <div class=\"multiple\"\n        *ngIf=\"multiple\">\n        <div class=\"option\"\n            *ngFor=\"let option of optionList.selection\">\n            <span class=\"deselect-option\"\n                (click)=onDeselectOptionClick(option)>\n                &#x2715;\n            </span>\n            {{option.label}}\n        </div>\n        <div class=\"placeholder\"\n            *ngIf=\"!filterEnabled && !optionList.hasSelected\">\n            {{placeholderView}}\n        </div>\n        <input\n            *ngIf=\"filterEnabled\"\n            #filterInput\n            autocomplete=\"off\"\n            tabindex=\"-1\"\n            [placeholder]=\"placeholderView\"\n            [ngStyle]=\"{'width.px': filterInputWidth}\"\n            (input)=\"onFilterInput($event.target.value)\"\n            (keydown)=\"onMultipleFilterKeydown($event)\"\n            (focus)=\"onMultipleFilterFocus()\"/>\n    </div>\n\n</div>\n<select-dropdown\n    *ngIf=\"isOpen\"\n    #dropdown\n    [multiple]=\"multiple\"\n    [optionList]=\"optionList\"\n    [notFoundMsg]=\"notFoundMsg\"\n    [highlightColor]=\"highlightColor\"\n    [highlightTextColor]=\"highlightTextColor\"\n    [filterEnabled]=\"filterEnabled\"\n    [placeholder]=\"filterPlaceholder\"\n    [width]=\"width\"\n    [top]=\"top\"\n    [left]=\"left\"\n    [optionTemplate]=\"optionTemplate\"\n    (optionClicked)=\"onDropdownOptionClicked($event)\"\n    (optionsListClick)=\"onOptionsListClick()\"\n    (singleFilterClick)=\"onSingleFilterClick()\"\n    (singleFilterFocus)=\"onSingleFilterFocus()\"\n    (singleFilterInput)=\"onFilterInput($event)\"\n    (singleFilterKeydown)=\"onSingleFilterKeydown($event)\">\n</select-dropdown>\n";


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var option_1 = __webpack_require__(78);
var diacritics_1 = __webpack_require__(79);
var OptionList = (function () {
    function OptionList(options) {
        /* Consider using these for performance improvement. */
        // private _selection: Array<Option>;
        // private _filtered: Array<Option>;
        // private _value: Array<string>;
        this._highlightedOption = null;
        if (typeof options === 'undefined' || options === null) {
            options = [];
        }
        this._options = options.map(function (option) {
            var o = new option_1.Option(option);
            if (option.disabled) {
                o.disabled = true;
            }
            return o;
        });
        this._hasShown = this._options.length > 0;
        this.highlight();
    }
    Object.defineProperty(OptionList.prototype, "hasShown", {
        get: function () {
            return this._hasShown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OptionList.prototype, "hasSelected", {
        get: function () {
            return this._hasSelected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OptionList.prototype, "options", {
        /** Options. **/
        get: function () {
            return this._options;
        },
        enumerable: true,
        configurable: true
    });
    OptionList.prototype.getOptionsByValue = function (value) {
        return this.options.filter(function (option) {
            return option.value === value;
        });
    };
    Object.defineProperty(OptionList.prototype, "value", {
        /** Value. **/
        get: function () {
            return this.selection.map(function (option) { return option.value; });
        },
        set: function (v) {
            v = typeof v === 'undefined' || v === null ? [] : v;
            this.options.forEach(function (option) {
                option.selected = v.indexOf(option.value) > -1;
            });
            this.updateHasSelected();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OptionList.prototype, "selection", {
        /** Selection. **/
        get: function () {
            return this.options.filter(function (option) { return option.selected; });
        },
        enumerable: true,
        configurable: true
    });
    OptionList.prototype.select = function (option, multiple) {
        if (!multiple) {
            this.clearSelection();
        }
        option.selected = true;
        this.updateHasSelected();
    };
    OptionList.prototype.deselect = function (option) {
        option.selected = false;
        this.updateHasSelected();
    };
    OptionList.prototype.clearSelection = function () {
        this.options.forEach(function (option) {
            option.selected = false;
        });
        this._hasSelected = false;
    };
    OptionList.prototype.updateHasSelected = function () {
        this._hasSelected = this.options.some(function (option) { return option.selected; });
    };
    Object.defineProperty(OptionList.prototype, "filtered", {
        /** Filter. **/
        get: function () {
            return this.options.filter(function (option) { return option.shown; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OptionList.prototype, "filteredEnabled", {
        get: function () {
            return this.options.filter(function (option) { return option.shown && !option.disabled; });
        },
        enumerable: true,
        configurable: true
    });
    OptionList.prototype.filter = function (term) {
        var anyShown = false;
        if (term.trim() === '') {
            this.resetFilter();
            anyShown = this.options.length > 0;
        }
        else {
            this.options.forEach(function (option) {
                var l = diacritics_1.Diacritics.strip(option.label).toUpperCase();
                var t = diacritics_1.Diacritics.strip(term).toUpperCase();
                option.shown = l.indexOf(t) > -1;
                if (option.shown) {
                    anyShown = true;
                }
            });
        }
        this.highlight();
        this._hasShown = anyShown;
        return anyShown;
    };
    OptionList.prototype.resetFilter = function () {
        this.options.forEach(function (option) {
            option.shown = true;
        });
    };
    Object.defineProperty(OptionList.prototype, "highlightedOption", {
        /** Highlight. **/
        get: function () {
            return this._highlightedOption;
        },
        enumerable: true,
        configurable: true
    });
    OptionList.prototype.highlight = function () {
        var option = this.hasShownSelected() ?
            this.getFirstShownSelected() : this.getFirstShown();
        this.highlightOption(option);
    };
    OptionList.prototype.highlightOption = function (option) {
        this.clearHighlightedOption();
        if (option !== null) {
            option.highlighted = true;
            this._highlightedOption = option;
        }
    };
    OptionList.prototype.highlightNextOption = function () {
        var shownEnabledOptions = this.filteredEnabled;
        var index = this.getHighlightedIndexFromList(shownEnabledOptions);
        if (index > -1 && index < shownEnabledOptions.length - 1) {
            this.highlightOption(shownEnabledOptions[index + 1]);
        }
    };
    OptionList.prototype.highlightPreviousOption = function () {
        var shownEnabledOptions = this.filteredEnabled;
        var index = this.getHighlightedIndexFromList(shownEnabledOptions);
        if (index > 0) {
            this.highlightOption(shownEnabledOptions[index - 1]);
        }
    };
    OptionList.prototype.clearHighlightedOption = function () {
        if (this.highlightedOption !== null) {
            this.highlightedOption.highlighted = false;
            this._highlightedOption = null;
        }
    };
    OptionList.prototype.getHighlightedIndexFromList = function (options) {
        for (var i = 0; i < options.length; i++) {
            if (options[i].highlighted) {
                return i;
            }
        }
        return -1;
    };
    OptionList.prototype.getHighlightedIndex = function () {
        return this.getHighlightedIndexFromList(this.filtered);
    };
    /** Util. **/
    OptionList.prototype.hasShownSelected = function () {
        return this.options.some(function (option) {
            return option.shown && option.selected;
        });
    };
    OptionList.prototype.getFirstShown = function () {
        for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
            var option = _a[_i];
            if (option.shown) {
                return option;
            }
        }
        return null;
    };
    OptionList.prototype.getFirstShownSelected = function () {
        for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
            var option = _a[_i];
            if (option.shown && option.selected) {
                return option;
            }
        }
        return null;
    };
    // v0 and v1 are assumed not to be undefined or null.
    OptionList.equalValues = function (v0, v1) {
        if (v0.length !== v1.length) {
            return false;
        }
        var a = v0.slice().sort();
        var b = v1.slice().sort();
        return a.every(function (v, i) {
            return v === b[i];
        });
    };
    return OptionList;
}());
exports.OptionList = OptionList;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Option = (function () {
    function Option(option) {
        this.wrappedOption = option;
        this.disabled = false;
        this.highlighted = false;
        this.selected = false;
        this.shown = true;
    }
    Object.defineProperty(Option.prototype, "value", {
        get: function () {
            return this.wrappedOption.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Option.prototype, "label", {
        get: function () {
            return this.wrappedOption.label;
        },
        enumerable: true,
        configurable: true
    });
    return Option;
}());
exports.Option = Option;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Diacritics = (function () {
    function Diacritics() {
    }
    Diacritics.strip = function (text) {
        var _this = this;
        var match = function (a) {
            return _this.DIACRITICS[a] || a;
        };
        return text.replace(/[^\u0000-\u007E]/g, match);
    };
    return Diacritics;
}());
Diacritics.DIACRITICS = {
    '\u24B6': 'A',
    '\uFF21': 'A',
    '\u00C0': 'A',
    '\u00C1': 'A',
    '\u00C2': 'A',
    '\u1EA6': 'A',
    '\u1EA4': 'A',
    '\u1EAA': 'A',
    '\u1EA8': 'A',
    '\u00C3': 'A',
    '\u0100': 'A',
    '\u0102': 'A',
    '\u1EB0': 'A',
    '\u1EAE': 'A',
    '\u1EB4': 'A',
    '\u1EB2': 'A',
    '\u0226': 'A',
    '\u01E0': 'A',
    '\u00C4': 'A',
    '\u01DE': 'A',
    '\u1EA2': 'A',
    '\u00C5': 'A',
    '\u01FA': 'A',
    '\u01CD': 'A',
    '\u0200': 'A',
    '\u0202': 'A',
    '\u1EA0': 'A',
    '\u1EAC': 'A',
    '\u1EB6': 'A',
    '\u1E00': 'A',
    '\u0104': 'A',
    '\u023A': 'A',
    '\u2C6F': 'A',
    '\uA732': 'AA',
    '\u00C6': 'AE',
    '\u01FC': 'AE',
    '\u01E2': 'AE',
    '\uA734': 'AO',
    '\uA736': 'AU',
    '\uA738': 'AV',
    '\uA73A': 'AV',
    '\uA73C': 'AY',
    '\u24B7': 'B',
    '\uFF22': 'B',
    '\u1E02': 'B',
    '\u1E04': 'B',
    '\u1E06': 'B',
    '\u0243': 'B',
    '\u0182': 'B',
    '\u0181': 'B',
    '\u24B8': 'C',
    '\uFF23': 'C',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010A': 'C',
    '\u010C': 'C',
    '\u00C7': 'C',
    '\u1E08': 'C',
    '\u0187': 'C',
    '\u023B': 'C',
    '\uA73E': 'C',
    '\u24B9': 'D',
    '\uFF24': 'D',
    '\u1E0A': 'D',
    '\u010E': 'D',
    '\u1E0C': 'D',
    '\u1E10': 'D',
    '\u1E12': 'D',
    '\u1E0E': 'D',
    '\u0110': 'D',
    '\u018B': 'D',
    '\u018A': 'D',
    '\u0189': 'D',
    '\uA779': 'D',
    '\u01F1': 'DZ',
    '\u01C4': 'DZ',
    '\u01F2': 'Dz',
    '\u01C5': 'Dz',
    '\u24BA': 'E',
    '\uFF25': 'E',
    '\u00C8': 'E',
    '\u00C9': 'E',
    '\u00CA': 'E',
    '\u1EC0': 'E',
    '\u1EBE': 'E',
    '\u1EC4': 'E',
    '\u1EC2': 'E',
    '\u1EBC': 'E',
    '\u0112': 'E',
    '\u1E14': 'E',
    '\u1E16': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u00CB': 'E',
    '\u1EBA': 'E',
    '\u011A': 'E',
    '\u0204': 'E',
    '\u0206': 'E',
    '\u1EB8': 'E',
    '\u1EC6': 'E',
    '\u0228': 'E',
    '\u1E1C': 'E',
    '\u0118': 'E',
    '\u1E18': 'E',
    '\u1E1A': 'E',
    '\u0190': 'E',
    '\u018E': 'E',
    '\u24BB': 'F',
    '\uFF26': 'F',
    '\u1E1E': 'F',
    '\u0191': 'F',
    '\uA77B': 'F',
    '\u24BC': 'G',
    '\uFF27': 'G',
    '\u01F4': 'G',
    '\u011C': 'G',
    '\u1E20': 'G',
    '\u011E': 'G',
    '\u0120': 'G',
    '\u01E6': 'G',
    '\u0122': 'G',
    '\u01E4': 'G',
    '\u0193': 'G',
    '\uA7A0': 'G',
    '\uA77D': 'G',
    '\uA77E': 'G',
    '\u24BD': 'H',
    '\uFF28': 'H',
    '\u0124': 'H',
    '\u1E22': 'H',
    '\u1E26': 'H',
    '\u021E': 'H',
    '\u1E24': 'H',
    '\u1E28': 'H',
    '\u1E2A': 'H',
    '\u0126': 'H',
    '\u2C67': 'H',
    '\u2C75': 'H',
    '\uA78D': 'H',
    '\u24BE': 'I',
    '\uFF29': 'I',
    '\u00CC': 'I',
    '\u00CD': 'I',
    '\u00CE': 'I',
    '\u0128': 'I',
    '\u012A': 'I',
    '\u012C': 'I',
    '\u0130': 'I',
    '\u00CF': 'I',
    '\u1E2E': 'I',
    '\u1EC8': 'I',
    '\u01CF': 'I',
    '\u0208': 'I',
    '\u020A': 'I',
    '\u1ECA': 'I',
    '\u012E': 'I',
    '\u1E2C': 'I',
    '\u0197': 'I',
    '\u24BF': 'J',
    '\uFF2A': 'J',
    '\u0134': 'J',
    '\u0248': 'J',
    '\u24C0': 'K',
    '\uFF2B': 'K',
    '\u1E30': 'K',
    '\u01E8': 'K',
    '\u1E32': 'K',
    '\u0136': 'K',
    '\u1E34': 'K',
    '\u0198': 'K',
    '\u2C69': 'K',
    '\uA740': 'K',
    '\uA742': 'K',
    '\uA744': 'K',
    '\uA7A2': 'K',
    '\u24C1': 'L',
    '\uFF2C': 'L',
    '\u013F': 'L',
    '\u0139': 'L',
    '\u013D': 'L',
    '\u1E36': 'L',
    '\u1E38': 'L',
    '\u013B': 'L',
    '\u1E3C': 'L',
    '\u1E3A': 'L',
    '\u0141': 'L',
    '\u023D': 'L',
    '\u2C62': 'L',
    '\u2C60': 'L',
    '\uA748': 'L',
    '\uA746': 'L',
    '\uA780': 'L',
    '\u01C7': 'LJ',
    '\u01C8': 'Lj',
    '\u24C2': 'M',
    '\uFF2D': 'M',
    '\u1E3E': 'M',
    '\u1E40': 'M',
    '\u1E42': 'M',
    '\u2C6E': 'M',
    '\u019C': 'M',
    '\u24C3': 'N',
    '\uFF2E': 'N',
    '\u01F8': 'N',
    '\u0143': 'N',
    '\u00D1': 'N',
    '\u1E44': 'N',
    '\u0147': 'N',
    '\u1E46': 'N',
    '\u0145': 'N',
    '\u1E4A': 'N',
    '\u1E48': 'N',
    '\u0220': 'N',
    '\u019D': 'N',
    '\uA790': 'N',
    '\uA7A4': 'N',
    '\u01CA': 'NJ',
    '\u01CB': 'Nj',
    '\u24C4': 'O',
    '\uFF2F': 'O',
    '\u00D2': 'O',
    '\u00D3': 'O',
    '\u00D4': 'O',
    '\u1ED2': 'O',
    '\u1ED0': 'O',
    '\u1ED6': 'O',
    '\u1ED4': 'O',
    '\u00D5': 'O',
    '\u1E4C': 'O',
    '\u022C': 'O',
    '\u1E4E': 'O',
    '\u014C': 'O',
    '\u1E50': 'O',
    '\u1E52': 'O',
    '\u014E': 'O',
    '\u022E': 'O',
    '\u0230': 'O',
    '\u00D6': 'O',
    '\u022A': 'O',
    '\u1ECE': 'O',
    '\u0150': 'O',
    '\u01D1': 'O',
    '\u020C': 'O',
    '\u020E': 'O',
    '\u01A0': 'O',
    '\u1EDC': 'O',
    '\u1EDA': 'O',
    '\u1EE0': 'O',
    '\u1EDE': 'O',
    '\u1EE2': 'O',
    '\u1ECC': 'O',
    '\u1ED8': 'O',
    '\u01EA': 'O',
    '\u01EC': 'O',
    '\u00D8': 'O',
    '\u01FE': 'O',
    '\u0186': 'O',
    '\u019F': 'O',
    '\uA74A': 'O',
    '\uA74C': 'O',
    '\u01A2': 'OI',
    '\uA74E': 'OO',
    '\u0222': 'OU',
    '\u24C5': 'P',
    '\uFF30': 'P',
    '\u1E54': 'P',
    '\u1E56': 'P',
    '\u01A4': 'P',
    '\u2C63': 'P',
    '\uA750': 'P',
    '\uA752': 'P',
    '\uA754': 'P',
    '\u24C6': 'Q',
    '\uFF31': 'Q',
    '\uA756': 'Q',
    '\uA758': 'Q',
    '\u024A': 'Q',
    '\u24C7': 'R',
    '\uFF32': 'R',
    '\u0154': 'R',
    '\u1E58': 'R',
    '\u0158': 'R',
    '\u0210': 'R',
    '\u0212': 'R',
    '\u1E5A': 'R',
    '\u1E5C': 'R',
    '\u0156': 'R',
    '\u1E5E': 'R',
    '\u024C': 'R',
    '\u2C64': 'R',
    '\uA75A': 'R',
    '\uA7A6': 'R',
    '\uA782': 'R',
    '\u24C8': 'S',
    '\uFF33': 'S',
    '\u1E9E': 'S',
    '\u015A': 'S',
    '\u1E64': 'S',
    '\u015C': 'S',
    '\u1E60': 'S',
    '\u0160': 'S',
    '\u1E66': 'S',
    '\u1E62': 'S',
    '\u1E68': 'S',
    '\u0218': 'S',
    '\u015E': 'S',
    '\u2C7E': 'S',
    '\uA7A8': 'S',
    '\uA784': 'S',
    '\u24C9': 'T',
    '\uFF34': 'T',
    '\u1E6A': 'T',
    '\u0164': 'T',
    '\u1E6C': 'T',
    '\u021A': 'T',
    '\u0162': 'T',
    '\u1E70': 'T',
    '\u1E6E': 'T',
    '\u0166': 'T',
    '\u01AC': 'T',
    '\u01AE': 'T',
    '\u023E': 'T',
    '\uA786': 'T',
    '\uA728': 'TZ',
    '\u24CA': 'U',
    '\uFF35': 'U',
    '\u00D9': 'U',
    '\u00DA': 'U',
    '\u00DB': 'U',
    '\u0168': 'U',
    '\u1E78': 'U',
    '\u016A': 'U',
    '\u1E7A': 'U',
    '\u016C': 'U',
    '\u00DC': 'U',
    '\u01DB': 'U',
    '\u01D7': 'U',
    '\u01D5': 'U',
    '\u01D9': 'U',
    '\u1EE6': 'U',
    '\u016E': 'U',
    '\u0170': 'U',
    '\u01D3': 'U',
    '\u0214': 'U',
    '\u0216': 'U',
    '\u01AF': 'U',
    '\u1EEA': 'U',
    '\u1EE8': 'U',
    '\u1EEE': 'U',
    '\u1EEC': 'U',
    '\u1EF0': 'U',
    '\u1EE4': 'U',
    '\u1E72': 'U',
    '\u0172': 'U',
    '\u1E76': 'U',
    '\u1E74': 'U',
    '\u0244': 'U',
    '\u24CB': 'V',
    '\uFF36': 'V',
    '\u1E7C': 'V',
    '\u1E7E': 'V',
    '\u01B2': 'V',
    '\uA75E': 'V',
    '\u0245': 'V',
    '\uA760': 'VY',
    '\u24CC': 'W',
    '\uFF37': 'W',
    '\u1E80': 'W',
    '\u1E82': 'W',
    '\u0174': 'W',
    '\u1E86': 'W',
    '\u1E84': 'W',
    '\u1E88': 'W',
    '\u2C72': 'W',
    '\u24CD': 'X',
    '\uFF38': 'X',
    '\u1E8A': 'X',
    '\u1E8C': 'X',
    '\u24CE': 'Y',
    '\uFF39': 'Y',
    '\u1EF2': 'Y',
    '\u00DD': 'Y',
    '\u0176': 'Y',
    '\u1EF8': 'Y',
    '\u0232': 'Y',
    '\u1E8E': 'Y',
    '\u0178': 'Y',
    '\u1EF6': 'Y',
    '\u1EF4': 'Y',
    '\u01B3': 'Y',
    '\u024E': 'Y',
    '\u1EFE': 'Y',
    '\u24CF': 'Z',
    '\uFF3A': 'Z',
    '\u0179': 'Z',
    '\u1E90': 'Z',
    '\u017B': 'Z',
    '\u017D': 'Z',
    '\u1E92': 'Z',
    '\u1E94': 'Z',
    '\u01B5': 'Z',
    '\u0224': 'Z',
    '\u2C7F': 'Z',
    '\u2C6B': 'Z',
    '\uA762': 'Z',
    '\u24D0': 'a',
    '\uFF41': 'a',
    '\u1E9A': 'a',
    '\u00E0': 'a',
    '\u00E1': 'a',
    '\u00E2': 'a',
    '\u1EA7': 'a',
    '\u1EA5': 'a',
    '\u1EAB': 'a',
    '\u1EA9': 'a',
    '\u00E3': 'a',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u1EB1': 'a',
    '\u1EAF': 'a',
    '\u1EB5': 'a',
    '\u1EB3': 'a',
    '\u0227': 'a',
    '\u01E1': 'a',
    '\u00E4': 'a',
    '\u01DF': 'a',
    '\u1EA3': 'a',
    '\u00E5': 'a',
    '\u01FB': 'a',
    '\u01CE': 'a',
    '\u0201': 'a',
    '\u0203': 'a',
    '\u1EA1': 'a',
    '\u1EAD': 'a',
    '\u1EB7': 'a',
    '\u1E01': 'a',
    '\u0105': 'a',
    '\u2C65': 'a',
    '\u0250': 'a',
    '\uA733': 'aa',
    '\u00E6': 'ae',
    '\u01FD': 'ae',
    '\u01E3': 'ae',
    '\uA735': 'ao',
    '\uA737': 'au',
    '\uA739': 'av',
    '\uA73B': 'av',
    '\uA73D': 'ay',
    '\u24D1': 'b',
    '\uFF42': 'b',
    '\u1E03': 'b',
    '\u1E05': 'b',
    '\u1E07': 'b',
    '\u0180': 'b',
    '\u0183': 'b',
    '\u0253': 'b',
    '\u24D2': 'c',
    '\uFF43': 'c',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010B': 'c',
    '\u010D': 'c',
    '\u00E7': 'c',
    '\u1E09': 'c',
    '\u0188': 'c',
    '\u023C': 'c',
    '\uA73F': 'c',
    '\u2184': 'c',
    '\u24D3': 'd',
    '\uFF44': 'd',
    '\u1E0B': 'd',
    '\u010F': 'd',
    '\u1E0D': 'd',
    '\u1E11': 'd',
    '\u1E13': 'd',
    '\u1E0F': 'd',
    '\u0111': 'd',
    '\u018C': 'd',
    '\u0256': 'd',
    '\u0257': 'd',
    '\uA77A': 'd',
    '\u01F3': 'dz',
    '\u01C6': 'dz',
    '\u24D4': 'e',
    '\uFF45': 'e',
    '\u00E8': 'e',
    '\u00E9': 'e',
    '\u00EA': 'e',
    '\u1EC1': 'e',
    '\u1EBF': 'e',
    '\u1EC5': 'e',
    '\u1EC3': 'e',
    '\u1EBD': 'e',
    '\u0113': 'e',
    '\u1E15': 'e',
    '\u1E17': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u00EB': 'e',
    '\u1EBB': 'e',
    '\u011B': 'e',
    '\u0205': 'e',
    '\u0207': 'e',
    '\u1EB9': 'e',
    '\u1EC7': 'e',
    '\u0229': 'e',
    '\u1E1D': 'e',
    '\u0119': 'e',
    '\u1E19': 'e',
    '\u1E1B': 'e',
    '\u0247': 'e',
    '\u025B': 'e',
    '\u01DD': 'e',
    '\u24D5': 'f',
    '\uFF46': 'f',
    '\u1E1F': 'f',
    '\u0192': 'f',
    '\uA77C': 'f',
    '\u24D6': 'g',
    '\uFF47': 'g',
    '\u01F5': 'g',
    '\u011D': 'g',
    '\u1E21': 'g',
    '\u011F': 'g',
    '\u0121': 'g',
    '\u01E7': 'g',
    '\u0123': 'g',
    '\u01E5': 'g',
    '\u0260': 'g',
    '\uA7A1': 'g',
    '\u1D79': 'g',
    '\uA77F': 'g',
    '\u24D7': 'h',
    '\uFF48': 'h',
    '\u0125': 'h',
    '\u1E23': 'h',
    '\u1E27': 'h',
    '\u021F': 'h',
    '\u1E25': 'h',
    '\u1E29': 'h',
    '\u1E2B': 'h',
    '\u1E96': 'h',
    '\u0127': 'h',
    '\u2C68': 'h',
    '\u2C76': 'h',
    '\u0265': 'h',
    '\u0195': 'hv',
    '\u24D8': 'i',
    '\uFF49': 'i',
    '\u00EC': 'i',
    '\u00ED': 'i',
    '\u00EE': 'i',
    '\u0129': 'i',
    '\u012B': 'i',
    '\u012D': 'i',
    '\u00EF': 'i',
    '\u1E2F': 'i',
    '\u1EC9': 'i',
    '\u01D0': 'i',
    '\u0209': 'i',
    '\u020B': 'i',
    '\u1ECB': 'i',
    '\u012F': 'i',
    '\u1E2D': 'i',
    '\u0268': 'i',
    '\u0131': 'i',
    '\u24D9': 'j',
    '\uFF4A': 'j',
    '\u0135': 'j',
    '\u01F0': 'j',
    '\u0249': 'j',
    '\u24DA': 'k',
    '\uFF4B': 'k',
    '\u1E31': 'k',
    '\u01E9': 'k',
    '\u1E33': 'k',
    '\u0137': 'k',
    '\u1E35': 'k',
    '\u0199': 'k',
    '\u2C6A': 'k',
    '\uA741': 'k',
    '\uA743': 'k',
    '\uA745': 'k',
    '\uA7A3': 'k',
    '\u24DB': 'l',
    '\uFF4C': 'l',
    '\u0140': 'l',
    '\u013A': 'l',
    '\u013E': 'l',
    '\u1E37': 'l',
    '\u1E39': 'l',
    '\u013C': 'l',
    '\u1E3D': 'l',
    '\u1E3B': 'l',
    '\u017F': 'l',
    '\u0142': 'l',
    '\u019A': 'l',
    '\u026B': 'l',
    '\u2C61': 'l',
    '\uA749': 'l',
    '\uA781': 'l',
    '\uA747': 'l',
    '\u01C9': 'lj',
    '\u24DC': 'm',
    '\uFF4D': 'm',
    '\u1E3F': 'm',
    '\u1E41': 'm',
    '\u1E43': 'm',
    '\u0271': 'm',
    '\u026F': 'm',
    '\u24DD': 'n',
    '\uFF4E': 'n',
    '\u01F9': 'n',
    '\u0144': 'n',
    '\u00F1': 'n',
    '\u1E45': 'n',
    '\u0148': 'n',
    '\u1E47': 'n',
    '\u0146': 'n',
    '\u1E4B': 'n',
    '\u1E49': 'n',
    '\u019E': 'n',
    '\u0272': 'n',
    '\u0149': 'n',
    '\uA791': 'n',
    '\uA7A5': 'n',
    '\u01CC': 'nj',
    '\u24DE': 'o',
    '\uFF4F': 'o',
    '\u00F2': 'o',
    '\u00F3': 'o',
    '\u00F4': 'o',
    '\u1ED3': 'o',
    '\u1ED1': 'o',
    '\u1ED7': 'o',
    '\u1ED5': 'o',
    '\u00F5': 'o',
    '\u1E4D': 'o',
    '\u022D': 'o',
    '\u1E4F': 'o',
    '\u014D': 'o',
    '\u1E51': 'o',
    '\u1E53': 'o',
    '\u014F': 'o',
    '\u022F': 'o',
    '\u0231': 'o',
    '\u00F6': 'o',
    '\u022B': 'o',
    '\u1ECF': 'o',
    '\u0151': 'o',
    '\u01D2': 'o',
    '\u020D': 'o',
    '\u020F': 'o',
    '\u01A1': 'o',
    '\u1EDD': 'o',
    '\u1EDB': 'o',
    '\u1EE1': 'o',
    '\u1EDF': 'o',
    '\u1EE3': 'o',
    '\u1ECD': 'o',
    '\u1ED9': 'o',
    '\u01EB': 'o',
    '\u01ED': 'o',
    '\u00F8': 'o',
    '\u01FF': 'o',
    '\u0254': 'o',
    '\uA74B': 'o',
    '\uA74D': 'o',
    '\u0275': 'o',
    '\u01A3': 'oi',
    '\u0223': 'ou',
    '\uA74F': 'oo',
    '\u24DF': 'p',
    '\uFF50': 'p',
    '\u1E55': 'p',
    '\u1E57': 'p',
    '\u01A5': 'p',
    '\u1D7D': 'p',
    '\uA751': 'p',
    '\uA753': 'p',
    '\uA755': 'p',
    '\u24E0': 'q',
    '\uFF51': 'q',
    '\u024B': 'q',
    '\uA757': 'q',
    '\uA759': 'q',
    '\u24E1': 'r',
    '\uFF52': 'r',
    '\u0155': 'r',
    '\u1E59': 'r',
    '\u0159': 'r',
    '\u0211': 'r',
    '\u0213': 'r',
    '\u1E5B': 'r',
    '\u1E5D': 'r',
    '\u0157': 'r',
    '\u1E5F': 'r',
    '\u024D': 'r',
    '\u027D': 'r',
    '\uA75B': 'r',
    '\uA7A7': 'r',
    '\uA783': 'r',
    '\u24E2': 's',
    '\uFF53': 's',
    '\u00DF': 's',
    '\u015B': 's',
    '\u1E65': 's',
    '\u015D': 's',
    '\u1E61': 's',
    '\u0161': 's',
    '\u1E67': 's',
    '\u1E63': 's',
    '\u1E69': 's',
    '\u0219': 's',
    '\u015F': 's',
    '\u023F': 's',
    '\uA7A9': 's',
    '\uA785': 's',
    '\u1E9B': 's',
    '\u24E3': 't',
    '\uFF54': 't',
    '\u1E6B': 't',
    '\u1E97': 't',
    '\u0165': 't',
    '\u1E6D': 't',
    '\u021B': 't',
    '\u0163': 't',
    '\u1E71': 't',
    '\u1E6F': 't',
    '\u0167': 't',
    '\u01AD': 't',
    '\u0288': 't',
    '\u2C66': 't',
    '\uA787': 't',
    '\uA729': 'tz',
    '\u24E4': 'u',
    '\uFF55': 'u',
    '\u00F9': 'u',
    '\u00FA': 'u',
    '\u00FB': 'u',
    '\u0169': 'u',
    '\u1E79': 'u',
    '\u016B': 'u',
    '\u1E7B': 'u',
    '\u016D': 'u',
    '\u00FC': 'u',
    '\u01DC': 'u',
    '\u01D8': 'u',
    '\u01D6': 'u',
    '\u01DA': 'u',
    '\u1EE7': 'u',
    '\u016F': 'u',
    '\u0171': 'u',
    '\u01D4': 'u',
    '\u0215': 'u',
    '\u0217': 'u',
    '\u01B0': 'u',
    '\u1EEB': 'u',
    '\u1EE9': 'u',
    '\u1EEF': 'u',
    '\u1EED': 'u',
    '\u1EF1': 'u',
    '\u1EE5': 'u',
    '\u1E73': 'u',
    '\u0173': 'u',
    '\u1E77': 'u',
    '\u1E75': 'u',
    '\u0289': 'u',
    '\u24E5': 'v',
    '\uFF56': 'v',
    '\u1E7D': 'v',
    '\u1E7F': 'v',
    '\u028B': 'v',
    '\uA75F': 'v',
    '\u028C': 'v',
    '\uA761': 'vy',
    '\u24E6': 'w',
    '\uFF57': 'w',
    '\u1E81': 'w',
    '\u1E83': 'w',
    '\u0175': 'w',
    '\u1E87': 'w',
    '\u1E85': 'w',
    '\u1E98': 'w',
    '\u1E89': 'w',
    '\u2C73': 'w',
    '\u24E7': 'x',
    '\uFF58': 'x',
    '\u1E8B': 'x',
    '\u1E8D': 'x',
    '\u24E8': 'y',
    '\uFF59': 'y',
    '\u1EF3': 'y',
    '\u00FD': 'y',
    '\u0177': 'y',
    '\u1EF9': 'y',
    '\u0233': 'y',
    '\u1E8F': 'y',
    '\u00FF': 'y',
    '\u1EF7': 'y',
    '\u1E99': 'y',
    '\u1EF5': 'y',
    '\u01B4': 'y',
    '\u024F': 'y',
    '\u1EFF': 'y',
    '\u24E9': 'z',
    '\uFF5A': 'z',
    '\u017A': 'z',
    '\u1E91': 'z',
    '\u017C': 'z',
    '\u017E': 'z',
    '\u1E93': 'z',
    '\u1E95': 'z',
    '\u01B6': 'z',
    '\u0225': 'z',
    '\u0240': 'z',
    '\u2C6C': 'z',
    '\uA763': 'z',
    '\u0386': '\u0391',
    '\u0388': '\u0395',
    '\u0389': '\u0397',
    '\u038A': '\u0399',
    '\u03AA': '\u0399',
    '\u038C': '\u039F',
    '\u038E': '\u03A5',
    '\u03AB': '\u03A5',
    '\u038F': '\u03A9',
    '\u03AC': '\u03B1',
    '\u03AD': '\u03B5',
    '\u03AE': '\u03B7',
    '\u03AF': '\u03B9',
    '\u03CA': '\u03B9',
    '\u0390': '\u03B9',
    '\u03CC': '\u03BF',
    '\u03CD': '\u03C5',
    '\u03CB': '\u03C5',
    '\u03B0': '\u03C5',
    '\u03C9': '\u03C9',
    '\u03C2': '\u03C3'
};
exports.Diacritics = Diacritics;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var select_dropdown_component_css_1 = __webpack_require__(81);
var select_dropdown_component_html_1 = __webpack_require__(82);
var SelectDropdownComponent = (function () {
    function SelectDropdownComponent() {
        this.optionClicked = new core_1.EventEmitter();
        this.optionsListClick = new core_1.EventEmitter();
        this.singleFilterClick = new core_1.EventEmitter();
        this.singleFilterFocus = new core_1.EventEmitter();
        this.singleFilterInput = new core_1.EventEmitter();
        this.singleFilterKeydown = new core_1.EventEmitter();
        this.disabledColor = '#fff';
        this.disabledTextColor = '9e9e9e';
    }
    /** Event handlers. **/
    SelectDropdownComponent.prototype.ngOnInit = function () {
        this.optionsReset();
    };
    SelectDropdownComponent.prototype.ngOnChanges = function (changes) {
        if (changes.hasOwnProperty('optionList')) {
            this.optionsReset();
        }
    };
    SelectDropdownComponent.prototype.ngAfterViewInit = function () {
        this.moveHighlightedIntoView();
        if (!this.multiple && this.filterEnabled) {
            this.filterInput.nativeElement.focus();
        }
    };
    SelectDropdownComponent.prototype.onOptionsListClick = function () {
        this.optionsListClick.emit(null);
    };
    SelectDropdownComponent.prototype.onSingleFilterClick = function () {
        this.singleFilterClick.emit(null);
    };
    SelectDropdownComponent.prototype.onSingleFilterInput = function (event) {
        this.singleFilterInput.emit(event.target.value);
    };
    SelectDropdownComponent.prototype.onSingleFilterKeydown = function (event) {
        this.singleFilterKeydown.emit(event);
    };
    SelectDropdownComponent.prototype.onSingleFilterFocus = function () {
        this.singleFilterFocus.emit(null);
    };
    SelectDropdownComponent.prototype.onOptionsWheel = function (event) {
        this.handleOptionsWheel(event);
    };
    SelectDropdownComponent.prototype.onOptionMouseover = function (option) {
        this.optionList.highlightOption(option);
    };
    SelectDropdownComponent.prototype.onOptionClick = function (option) {
        this.optionClicked.emit(option);
    };
    /** Initialization. **/
    SelectDropdownComponent.prototype.optionsReset = function () {
        this.optionList.filter('');
        this.optionList.highlight();
    };
    /** View. **/
    SelectDropdownComponent.prototype.getOptionStyle = function (option) {
        if (option.highlighted) {
            var style = {};
            if (typeof this.highlightColor !== 'undefined') {
                style['background-color'] = this.highlightColor;
            }
            if (typeof this.highlightTextColor !== 'undefined') {
                style['color'] = this.highlightTextColor;
            }
            return style;
        }
        else {
            return {};
        }
    };
    SelectDropdownComponent.prototype.moveHighlightedIntoView = function () {
        var list = this.optionsList.nativeElement;
        var listHeight = list.offsetHeight;
        var itemIndex = this.optionList.getHighlightedIndex();
        if (itemIndex > -1) {
            var item = list.children[0].children[itemIndex];
            var itemHeight = item.offsetHeight;
            var itemTop = itemIndex * itemHeight;
            var itemBottom = itemTop + itemHeight;
            var viewTop = list.scrollTop;
            var viewBottom = viewTop + listHeight;
            if (itemBottom > viewBottom) {
                list.scrollTop = itemBottom - listHeight;
            }
            else if (itemTop < viewTop) {
                list.scrollTop = itemTop;
            }
        }
    };
    SelectDropdownComponent.prototype.handleOptionsWheel = function (e) {
        var div = this.optionsList.nativeElement;
        var atTop = div.scrollTop === 0;
        var atBottom = div.offsetHeight + div.scrollTop === div.scrollHeight;
        if (atTop && e.deltaY < 0) {
            e.preventDefault();
        }
        else if (atBottom && e.deltaY > 0) {
            e.preventDefault();
        }
    };
    return SelectDropdownComponent;
}());
SelectDropdownComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'select-dropdown',
                template: select_dropdown_component_html_1.TEMPLATE,
                styles: [select_dropdown_component_css_1.STYLE],
                encapsulation: core_1.ViewEncapsulation.None
            },] },
];
/** @nocollapse */
SelectDropdownComponent.ctorParameters = function () { return []; };
SelectDropdownComponent.propDecorators = {
    'filterEnabled': [{ type: core_1.Input },],
    'highlightColor': [{ type: core_1.Input },],
    'highlightTextColor': [{ type: core_1.Input },],
    'left': [{ type: core_1.Input },],
    'multiple': [{ type: core_1.Input },],
    'notFoundMsg': [{ type: core_1.Input },],
    'optionList': [{ type: core_1.Input },],
    'top': [{ type: core_1.Input },],
    'width': [{ type: core_1.Input },],
    'placeholder': [{ type: core_1.Input },],
    'optionTemplate': [{ type: core_1.Input },],
    'optionClicked': [{ type: core_1.Output },],
    'optionsListClick': [{ type: core_1.Output },],
    'singleFilterClick': [{ type: core_1.Output },],
    'singleFilterFocus': [{ type: core_1.Output },],
    'singleFilterInput': [{ type: core_1.Output },],
    'singleFilterKeydown': [{ type: core_1.Output },],
    'filterInput': [{ type: core_1.ViewChild, args: ['filterInput',] },],
    'optionsList': [{ type: core_1.ViewChild, args: ['optionsList',] },],
};
exports.SelectDropdownComponent = SelectDropdownComponent;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLE = "select-dropdown {\n  box-sizing: border-box;\n  font-family: Sans-Serif; }\n  select-dropdown * {\n    box-sizing: border-box;\n    font-family: Sans-Serif; }\n  select-dropdown > div {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-top: none;\n    box-sizing: border-box;\n    position: absolute;\n    z-index: 1; }\n    select-dropdown > div .filter {\n      padding: 3px;\n      width: 100%; }\n      select-dropdown > div .filter input {\n        border: 1px solid #eee;\n        box-sizing: border-box;\n        padding: 4px;\n        width: 100%; }\n    select-dropdown > div .options {\n      max-height: 200px;\n      overflow-y: auto; }\n      select-dropdown > div .options ul {\n        list-style: none;\n        margin: 0;\n        padding: 0; }\n        select-dropdown > div .options ul li {\n          padding: 4px 8px;\n          cursor: pointer;\n          user-select: none; }\n  select-dropdown .selected {\n    background-color: #e0e0e0; }\n    select-dropdown .selected.highlighted {\n      background-color: #2196F3;\n      color: #fff; }\n  select-dropdown .highlighted {\n    background-color: #2196F3;\n    color: #fff; }\n  select-dropdown .disabled {\n    background-color: #fff;\n    color: #9e9e9e;\n    cursor: default;\n    pointer-events: none; }\n";


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE = "<div\n    [ngStyle]=\"{'top.px': top, 'left.px': left, 'width.px': width}\">\n\n    <div class=\"filter\"\n        *ngIf=\"!multiple && filterEnabled\">\n        <input\n            #filterInput\n            autocomplete=\"off\"\n            [placeholder]=\"placeholder\"\n            (click)=\"onSingleFilterClick()\"\n            (input)=\"onSingleFilterInput($event)\"\n            (keydown)=\"onSingleFilterKeydown($event)\"\n            (focus)=\"onSingleFilterFocus()\">\n    </div>\n\n    <div class=\"options\"\n        (click)=\"onOptionsListClick()\"\n        #optionsList>\n        <ul\n            (wheel)=\"onOptionsWheel($event)\">\n            <li *ngFor=\"let option of optionList.filtered\"\n                [ngClass]=\"{'highlighted': option.highlighted, 'selected': option.selected, 'disabled': option.disabled}\"\n                [ngStyle]=\"getOptionStyle(option)\"\n                (click)=\"onOptionClick(option)\"\n                (mouseover)=\"onOptionMouseover(option)\">\n                <ng-template [ngOutletContext]=\"{option: option.wrappedOption}\" [ngTemplateOutlet]=\"optionTemplate\"></ng-template>\n                <span *ngIf=\"!optionTemplate\">{{option.label}}</span>\n            </li>\n            <li\n                *ngIf=\"!optionList.hasShown\"\n                class=\"message\">\n                {{notFoundMsg}}\n            </li>\n        </ul>\n    </div>\n</div>\n";


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_84__;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_85__;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_86__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.umd.min.js